import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  /** The `Date` scalar represents an ISO-8601 compliant date type. */
  Date: { input: any; output: any; }
  /** The `DateTime` scalar represents an ISO-8601 compliant date time type. */
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

export type ArtInsightPrompt = {
  __typename?: 'ARTInsightPrompt';
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  prompt?: Maybe<Scalars['String']['output']>;
  promptDisplayText?: Maybe<Scalars['String']['output']>;
};

export type ArtInsightPromptDetails = {
  __typename?: 'ARTInsightPromptDetails';
  lastUpdatedUtc?: Maybe<Scalars['DateTime']['output']>;
  prompts: Array<ArtInsightPrompt>;
};

export type ArtReportConfiguration = {
  __typename?: 'ARTReportConfiguration';
  qSearchUrl?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type AckRespondMsgDtoInput = {
  priorityId: Scalars['Int']['input'];
  respondMessage: Scalars['String']['input'];
};

export type ActFilteringDtoInput = {
  alertId: Scalars['String']['input'];
  buildingIds?: InputMaybe<Array<Scalars['String']['input']>>;
  departmentNames?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  floorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  staffIds?: InputMaybe<Array<Scalars['String']['input']>>;
  staffName?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type ActionFilteringDtoInput = {
  alertId: Scalars['String']['input'];
  buildingIds?: InputMaybe<Array<Scalars['String']['input']>>;
  departmentNames?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  floorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  staffIds?: InputMaybe<Array<Scalars['String']['input']>>;
  staffName?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type ActivityMilestoneFilterDtoInput = {
  dispenserId?: InputMaybe<Scalars['String']['input']>;
  dispenserTypeId?: InputMaybe<Scalars['Int']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  locationTypeId?: InputMaybe<Scalars['Int']['input']>;
  precautionId?: InputMaybe<Scalars['Int']['input']>;
  staffId?: InputMaybe<Scalars['Int']['input']>;
  staffTypeId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddArtRuleDtoInput = {
  assetGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  delay?: InputMaybe<Scalars['Int']['input']>;
  direction?: InputMaybe<AreaRestrictionDirection>;
  locationGroupIds: Array<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  parLevelId: Scalars['String']['input'];
  ruleAction: RuleActionInput;
  type: RuleType;
};

export type AddAssetDtoInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assetGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  assetGroupNames?: InputMaybe<Array<Scalars['String']['input']>>;
  assetNumber?: InputMaybe<Scalars['String']['input']>;
  assetTypeId?: InputMaybe<Scalars['String']['input']>;
  assetTypeName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerDepartment?: InputMaybe<Scalars['String']['input']>;
  preventativeMaintenanceDue?: InputMaybe<Scalars['String']['input']>;
  preventativeMaintenanceLastPerformed?: InputMaybe<Scalars['String']['input']>;
  rental?: InputMaybe<Scalars['Boolean']['input']>;
  rentalDateIssued?: InputMaybe<Scalars['String']['input']>;
  rentalExpectedReturnDate?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  tagNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AddAssetGroupDtoInput = {
  assets?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type AddAssetTypeDtoInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AddDepartmentDtoInput = {
  caDepartmentId: Scalars['Int']['input'];
  caDepartmentName: Scalars['String']['input'];
  caSiteId: Scalars['Int']['input'];
  caSiteName: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export type AddDeviceOptionsDtoInput = {
  dispenserTypeId?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  sensorId: Scalars['Int']['input'];
  sensorValue: Scalars['String']['input'];
};

export type AddEscalationDtoInput = {
  escalationDepartments: Array<EscalationDepartmentCustomInput>;
  escalationId: Scalars['String']['input'];
  escalationLevels: Array<EscalationLevelCustomInput>;
  escalationName: Scalars['String']['input'];
};

export type AddLocationDtoInput = {
  caDepartmentId: Scalars['Int']['input'];
  caLocationId: Scalars['Int']['input'];
  precautionId?: InputMaybe<Scalars['Int']['input']>;
};

export type AddMessageGroupDtoInput = {
  groupName: Scalars['String']['input'];
  outboundType: Array<Scalars['Int']['input']>;
  staffIds: Array<Scalars['Int']['input']>;
};

export type AddOutboundMsgDtoInput = {
  enableNearProximity: Scalars['Boolean']['input'];
  groupId: Scalars['String']['input'];
  groupName: Scalars['String']['input'];
  outboundTypes: Array<OutboundConfigTypeInput>;
  recipeintsIds: Array<OutboundConfigRecipientsInput>;
  triggerDepartmentId: Scalars['Int']['input'];
};

export type AddParLevelDtoInput = {
  assetTypeId?: InputMaybe<Scalars['String']['input']>;
  assetTypeName?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Array<Scalars['String']['input']>>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  maxCount: Scalars['Int']['input'];
  minCount: Scalars['Int']['input'];
  target: Scalars['Int']['input'];
};

export type AddRuleDtoInput = {
  audioFile: Scalars['String']['input'];
  isAssigned: Scalars['Boolean']['input'];
  isAudioEnabled: Scalars['Boolean']['input'];
  isCreateAlert: Scalars['Boolean']['input'];
  keyBitDecimal: Scalars['Int']['input'];
  rDepartments: Array<RDepartmentsInput>;
  ruleId: Scalars['Int']['input'];
  ruleName: Scalars['String']['input'];
};

export type AddSavedSearchesInput = {
  filters: Scalars['String']['input'];
  name: Scalars['String']['input'];
  query: Scalars['String']['input'];
};

export type AddScheduledNotificationInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['Int']['input']>;
  frequencyParameter?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  orderColumn?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  staffGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startHour?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type AddStaffGroupDtoInput = {
  name: Scalars['String']['input'];
  staffIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  staffNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AddUpdateIoTDeviceDtoInput = {
  clientId: Scalars['Int']['input'];
  deviceCode?: InputMaybe<Scalars['String']['input']>;
  deviceType?: InputMaybe<Scalars['String']['input']>;
};

export type AlertAcceptDtoInput = {
  alertId: Scalars['String']['input'];
};

export type AlertCloseDtoInput = {
  alertId: Scalars['String']['input'];
  respondMessage: Scalars['String']['input'];
};

export type AlertConditionDto = {
  __typename?: 'AlertConditionDto';
  alertEmItems: Array<AlertConditionEmItemDto>;
  alertEmItemsCount: Scalars['Int']['output'];
  alertRecipients: Array<AlertRecipientDto>;
  alertRecipientsCount: Scalars['Int']['output'];
  allowUserToSpecifyReopenTime: Scalars['Boolean']['output'];
  autoResponseEnabled: Scalars['Boolean']['output'];
  autoResponseMessage?: Maybe<Scalars['String']['output']>;
  autoResponseTimeMin: Scalars['Int']['output'];
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  customerId: Scalars['Int']['output'];
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  maxValue: Scalars['Int']['output'];
  minValue: Scalars['Int']['output'];
  probeType?: Maybe<ProbeTypeDto>;
  probeTypeId: Scalars['String']['output'];
  recipientGroupIds: Array<Scalars['String']['output']>;
  recipientGroups: Array<RecipientGroupDto>;
  reopenIfOutOfRangeEnabled: Scalars['Boolean']['output'];
  reopenTimeMin?: Maybe<Scalars['Int']['output']>;
  repeatDelayMin?: Maybe<Scalars['Int']['output']>;
  repeatMode: Scalars['String']['output'];
  rollingAvgTriggerEnabled: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type AlertConditionEmItemDto = {
  __typename?: 'AlertConditionEmItemDto';
  alertCondition?: Maybe<AlertConditionDto>;
  alertConditionId: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  customerId: Scalars['Int']['output'];
  emItem?: Maybe<EmItemDto>;
  emItemId: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type AlertDto = {
  __typename?: 'AlertDto';
  acknowledgedBy?: Maybe<Scalars['String']['output']>;
  acknowledgedUtc?: Maybe<Scalars['DateTime']['output']>;
  alertCondition?: Maybe<AlertConditionDto>;
  alertConditionId: Scalars['String']['output'];
  alertConditionMaxValue: Scalars['Int']['output'];
  alertConditionMinValue: Scalars['Int']['output'];
  alertConditionTitle: Scalars['String']['output'];
  closedBy?: Maybe<Scalars['String']['output']>;
  closedUtc?: Maybe<Scalars['DateTime']['output']>;
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  currentProbeValue: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  emItem?: Maybe<EmItemDto>;
  emItemId: Scalars['String']['output'];
  emItemName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  probe?: Maybe<ProbeDto>;
  probeId: Scalars['String']['output'];
  probeTypeDisplayUnits: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
  valueSnapshot: Scalars['Int']['output'];
};

export type AlertRecipientDto = {
  __typename?: 'AlertRecipientDto';
  alertCondition?: Maybe<AlertConditionDto>;
  alertConditionId?: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  customerId: Scalars['Int']['output'];
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  recipientGroup?: Maybe<RecipientGroupDto>;
  recipientGroupId?: Maybe<Scalars['String']['output']>;
  reportAfterMin?: Maybe<Scalars['Int']['output']>;
  staffId?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type AlertResponseDto = {
  __typename?: 'AlertResponseDto';
  alert?: Maybe<AlertDto>;
  alertId: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  customerId: Scalars['Int']['output'];
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type AlertStatusMessage = {
  __typename?: 'AlertStatusMessage';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<AlertStatusMessage>;
  idx?: Maybe<Scalars['String']['output']>;
  isCriticalResponse: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedOn?: Maybe<Scalars['String']['output']>;
};

export type AlertStatusUpdateDtoInput = {
  alertId: Scalars['String']['input'];
  isCriticalResponse?: InputMaybe<Scalars['Boolean']['input']>;
  statusUpdateMessage: Scalars['String']['input'];
};

export enum AreaRestrictionDirection {
  Enter = 'ENTER',
  Exit = 'EXIT',
  Unset = 'UNSET'
}

/** A segment of a collection. */
export type ArtAssetGroupsCollectionSegment = {
  __typename?: 'ArtAssetGroupsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<AssetGroups>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ArtAssetTypesCollectionSegment = {
  __typename?: 'ArtAssetTypesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<AssetTypes>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ArtAssetsCollectionSegment = {
  __typename?: 'ArtAssetsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Assets>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ArtCaLocationGroupsCollectionSegment = {
  __typename?: 'ArtCaLocationGroupsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<LocationGroups>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ArtLocationHierarchyCollectionSegment = {
  __typename?: 'ArtLocationHierarchyCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CaFloorList>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ArtLocationHistoryCollectionSegment = {
  __typename?: 'ArtLocationHistoryCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Locations>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ArtLocationsCollectionSegment = {
  __typename?: 'ArtLocationsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<AssetLocationList>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ArtParLevelDashboardCollectionSegment = {
  __typename?: 'ArtParLevelDashboardCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ParLevelLocation>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ArtParLevelsCollectionSegment = {
  __typename?: 'ArtParLevelsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ParLevelList>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ArtRuleEventsCollectionSegment = {
  __typename?: 'ArtRuleEventsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<RuleEventRecord>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ArtRulesCollectionSegment = {
  __typename?: 'ArtRulesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Rule>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ArtSavedSearchesCollectionSegment = {
  __typename?: 'ArtSavedSearchesCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<SavedSearches>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ArtScheduledNotificationsCollectionSegment = {
  __typename?: 'ArtScheduledNotificationsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<ScheduledNotification>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ArtSearchAssetsCollectionSegment = {
  __typename?: 'ArtSearchAssetsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Assets>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ArtSearchLocationsCollectionSegment = {
  __typename?: 'ArtSearchLocationsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<SearchLocations>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ArtStaffGroupsCollectionSegment = {
  __typename?: 'ArtStaffGroupsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<StaffGroups>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

/** A segment of a collection. */
export type ArtStaffListCollectionSegment = {
  __typename?: 'ArtStaffListCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<CaStaffList>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssetGroup = {
  __typename?: 'AssetGroup';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<AssetGroup>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AssetGroupFilterInput = {
  and?: InputMaybe<Array<AssetGroupFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AssetGroupFilterInput>>;
};

export type AssetGroupInfo = {
  __typename?: 'AssetGroupInfo';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<AssetGroupInfo>;
  hasId: Scalars['Boolean']['output'];
  hasName: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type AssetGroupInfoFilterInput = {
  and?: InputMaybe<Array<AssetGroupInfoFilterInput>>;
  hasId?: InputMaybe<BooleanOperationFilterInput>;
  hasName?: InputMaybe<BooleanOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AssetGroupInfoFilterInput>>;
};

export type AssetGroups = {
  __typename?: 'AssetGroups';
  assetGroupId?: Maybe<Scalars['String']['output']>;
  assets: Array<Assets>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  returnResponse: Response;
};

export type AssetGroupsFilterInput = {
  and?: InputMaybe<Array<AssetGroupsFilterInput>>;
  assetGroupId?: InputMaybe<StringOperationFilterInput>;
  assets?: InputMaybe<ListFilterInputTypeOfAssetsFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AssetGroupsFilterInput>>;
  returnResponse?: InputMaybe<ResponseFilterInput>;
};

export type AssetGroupsSortInput = {
  assetGroupId?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  returnResponse?: InputMaybe<ResponseSortInput>;
};

export type AssetLocationList = {
  __typename?: 'AssetLocationList';
  assetLocationTypeName?: Maybe<Scalars['String']['output']>;
  boundary?: Maybe<Boundary>;
  buildingName: Scalars['String']['output'];
  deptName: Scalars['String']['output'];
  floorId?: Maybe<Scalars['Int']['output']>;
  floorName: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  locationTypeName: Scalars['String']['output'];
  sensorId?: Maybe<Scalars['String']['output']>;
  siteName: Scalars['String']['output'];
  subBuildingName: Scalars['String']['output'];
};

export type AssetLocationListFilterInput = {
  and?: InputMaybe<Array<AssetLocationListFilterInput>>;
  assetLocationTypeName?: InputMaybe<StringOperationFilterInput>;
  boundary?: InputMaybe<BoundaryFilterInput>;
  buildingName?: InputMaybe<StringOperationFilterInput>;
  deptName?: InputMaybe<StringOperationFilterInput>;
  floorId?: InputMaybe<IntOperationFilterInput>;
  floorName?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  locationTypeName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AssetLocationListFilterInput>>;
  sensorId?: InputMaybe<StringOperationFilterInput>;
  siteName?: InputMaybe<StringOperationFilterInput>;
  subBuildingName?: InputMaybe<StringOperationFilterInput>;
};

export type AssetLocationListSortInput = {
  assetLocationTypeName?: InputMaybe<SortEnumType>;
  boundary?: InputMaybe<BoundarySortInput>;
  buildingName?: InputMaybe<SortEnumType>;
  deptName?: InputMaybe<SortEnumType>;
  floorId?: InputMaybe<SortEnumType>;
  floorName?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<SortEnumType>;
  locationTypeName?: InputMaybe<SortEnumType>;
  sensorId?: InputMaybe<SortEnumType>;
  siteName?: InputMaybe<SortEnumType>;
  subBuildingName?: InputMaybe<SortEnumType>;
};

export type AssetRemoveModel = {
  __typename?: 'AssetRemoveModel';
  id: Scalars['String']['output'];
  returnResponse: Response;
};

export type AssetTypes = {
  __typename?: 'AssetTypes';
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  returnResponse: Response;
};

export type AssetTypesFilterInput = {
  and?: InputMaybe<Array<AssetTypesFilterInput>>;
  description?: InputMaybe<StringOperationFilterInput>;
  icon?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AssetTypesFilterInput>>;
  returnResponse?: InputMaybe<ResponseFilterInput>;
};

export type AssetTypesSortInput = {
  description?: InputMaybe<SortEnumType>;
  icon?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  returnResponse?: InputMaybe<ResponseSortInput>;
};

export type Assets = {
  __typename?: 'Assets';
  archived: Scalars['Boolean']['output'];
  archivedBy?: Maybe<Scalars['String']['output']>;
  archivedUtc?: Maybe<Scalars['DateTime']['output']>;
  areaDepartmentIds?: Maybe<Array<Scalars['Int']['output']>>;
  areaDepartmentNames?: Maybe<Array<Scalars['String']['output']>>;
  assetGroup: Array<AssetGroupInfo>;
  assetLocationTypeId?: Maybe<Scalars['Int']['output']>;
  assetNumber?: Maybe<Scalars['String']['output']>;
  assetTypeId: Scalars['String']['output'];
  assetTypeName: Scalars['String']['output'];
  batteryStatus?: Maybe<BatteryStatus>;
  buildingId?: Maybe<Scalars['Int']['output']>;
  buildingName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  floorId?: Maybe<Scalars['Int']['output']>;
  floorName?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastSensedTime?: Maybe<Scalars['DateTime']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  locationType: LocationsType;
  longitude?: Maybe<Scalars['Float']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  ownerDepartment?: Maybe<Scalars['String']['output']>;
  preventativeMaintenanceDue?: Maybe<Scalars['Date']['output']>;
  preventativeMaintenanceLastPerformed?: Maybe<Scalars['String']['output']>;
  rental: Scalars['Boolean']['output'];
  rentalDateIssued?: Maybe<Scalars['String']['output']>;
  rentalExpectedReturnDate?: Maybe<Scalars['String']['output']>;
  returnResponse: Response;
  serialNumber?: Maybe<Scalars['String']['output']>;
  siteId?: Maybe<Scalars['Int']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  subBuildingId?: Maybe<Scalars['Int']['output']>;
  subBuildingName?: Maybe<Scalars['String']['output']>;
  tagId?: Maybe<Scalars['Int']['output']>;
  tagNumber?: Maybe<Scalars['String']['output']>;
  timeOfLocation?: Maybe<Scalars['DateTime']['output']>;
};

/** A segment of a collection. */
export type AssetsCollectionSegment = {
  __typename?: 'AssetsCollectionSegment';
  /** A flattened list of the items. */
  items?: Maybe<Array<Assets>>;
  /** Information to aid in pagination. */
  pageInfo: CollectionSegmentInfo;
  totalCount: Scalars['Int']['output'];
};

export type AssetsFilterInput = {
  and?: InputMaybe<Array<AssetsFilterInput>>;
  areaDepartmentIds?: InputMaybe<ListIntOperationFilterInput>;
  areaDepartmentNames?: InputMaybe<ListStringOperationFilterInput>;
  assetGroup?: InputMaybe<ListFilterInputTypeOfAssetGroupInfoFilterInput>;
  assetLocationTypeId?: InputMaybe<IntOperationFilterInput>;
  assetNumber?: InputMaybe<StringOperationFilterInput>;
  assetTypeId?: InputMaybe<StringOperationFilterInput>;
  assetTypeName?: InputMaybe<StringOperationFilterInput>;
  batteryStatus?: InputMaybe<NullableOfBatteryStatusOperationFilterInput>;
  buildingId?: InputMaybe<IntOperationFilterInput>;
  buildingName?: InputMaybe<StringOperationFilterInput>;
  description?: InputMaybe<StringOperationFilterInput>;
  floorId?: InputMaybe<IntOperationFilterInput>;
  floorName?: InputMaybe<StringOperationFilterInput>;
  icon?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastSensedTime?: InputMaybe<DateTimeOperationFilterInput>;
  latitude?: InputMaybe<FloatOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  locationType?: InputMaybe<LocationsTypeOperationFilterInput>;
  longitude?: InputMaybe<FloatOperationFilterInput>;
  manufacturer?: InputMaybe<StringOperationFilterInput>;
  model?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<AssetsFilterInput>>;
  ownerDepartment?: InputMaybe<StringOperationFilterInput>;
  preventativeMaintenanceDue?: InputMaybe<DateOperationFilterInput>;
  preventativeMaintenanceLastPerformed?: InputMaybe<StringOperationFilterInput>;
  rental?: InputMaybe<BooleanOperationFilterInput>;
  rentalDateIssued?: InputMaybe<StringOperationFilterInput>;
  rentalExpectedReturnDate?: InputMaybe<StringOperationFilterInput>;
  returnResponse?: InputMaybe<ResponseFilterInput>;
  serialNumber?: InputMaybe<StringOperationFilterInput>;
  siteId?: InputMaybe<IntOperationFilterInput>;
  siteName?: InputMaybe<StringOperationFilterInput>;
  subBuildingId?: InputMaybe<IntOperationFilterInput>;
  subBuildingName?: InputMaybe<StringOperationFilterInput>;
  tagId?: InputMaybe<IntOperationFilterInput>;
  tagNumber?: InputMaybe<StringOperationFilterInput>;
  timeOfLocation?: InputMaybe<DateTimeOperationFilterInput>;
};

export type AssetsSortInput = {
  archived?: InputMaybe<SortEnumType>;
  archivedBy?: InputMaybe<SortEnumType>;
  archivedUtc?: InputMaybe<SortEnumType>;
  assetLocationTypeId?: InputMaybe<SortEnumType>;
  assetNumber?: InputMaybe<SortEnumType>;
  assetTypeId?: InputMaybe<SortEnumType>;
  assetTypeName?: InputMaybe<SortEnumType>;
  batteryStatus?: InputMaybe<SortEnumType>;
  buildingId?: InputMaybe<SortEnumType>;
  buildingName?: InputMaybe<SortEnumType>;
  description?: InputMaybe<SortEnumType>;
  floorId?: InputMaybe<SortEnumType>;
  floorName?: InputMaybe<SortEnumType>;
  icon?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastSensedTime?: InputMaybe<SortEnumType>;
  latitude?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<SortEnumType>;
  locationType?: InputMaybe<SortEnumType>;
  longitude?: InputMaybe<SortEnumType>;
  manufacturer?: InputMaybe<SortEnumType>;
  model?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  ownerDepartment?: InputMaybe<SortEnumType>;
  preventativeMaintenanceDue?: InputMaybe<SortEnumType>;
  preventativeMaintenanceLastPerformed?: InputMaybe<SortEnumType>;
  rental?: InputMaybe<SortEnumType>;
  rentalDateIssued?: InputMaybe<SortEnumType>;
  rentalExpectedReturnDate?: InputMaybe<SortEnumType>;
  returnResponse?: InputMaybe<ResponseSortInput>;
  serialNumber?: InputMaybe<SortEnumType>;
  siteId?: InputMaybe<SortEnumType>;
  siteName?: InputMaybe<SortEnumType>;
  subBuildingId?: InputMaybe<SortEnumType>;
  subBuildingName?: InputMaybe<SortEnumType>;
  tagId?: InputMaybe<SortEnumType>;
  tagNumber?: InputMaybe<SortEnumType>;
  timeOfLocation?: InputMaybe<SortEnumType>;
};

export type AssignedPatient = {
  __typename?: 'AssignedPatient';
  patientId: Scalars['Int']['output'];
  patientName: Scalars['String']['output'];
};

export type AssignedStaff = {
  __typename?: 'AssignedStaff';
  departments?: Maybe<Array<CaDepartment>>;
  icon?: Maybe<Scalars['String']['output']>;
  icon_acronym?: Maybe<Scalars['String']['output']>;
  icon_color?: Maybe<Scalars['String']['output']>;
  staffId: Scalars['Int']['output'];
  staffType: Scalars['String']['output'];
  staffTypeId?: Maybe<Scalars['Int']['output']>;
};

export type AuthConfigDto = {
  __typename?: 'AuthConfigDto';
  authType: Scalars['String']['output'];
  configJson?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  customerId: Scalars['String']['output'];
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  securableId?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type AuthConfigListDto = {
  __typename?: 'AuthConfigListDto';
  authConfigs: Array<AuthConfigDto>;
  totalCount: Scalars['Int']['output'];
};

export enum BatteryStatus {
  Critical = 'CRITICAL',
  Depleted = 'DEPLETED',
  Failed = 'FAILED',
  Good = 'GOOD',
  Low = 'LOW',
  Unknown = 'UNKNOWN'
}

export type BatteryStatusModel = {
  __typename?: 'BatteryStatusModel';
  activityLevel?: Maybe<Scalars['String']['output']>;
  batteryBinRule?: Maybe<Scalars['String']['output']>;
  batteryFailureMsg?: Maybe<Scalars['String']['output']>;
  batteryReplacementIndication?: Maybe<Scalars['String']['output']>;
  batteryReplacementOn?: Maybe<Scalars['String']['output']>;
  binStatus?: Maybe<Scalars['String']['output']>;
  brConfirmationState?: Maybe<Scalars['String']['output']>;
  cActivityLevel?: Maybe<Scalars['String']['output']>;
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<BatteryStatusModel>;
  currentBatteryCapacity?: Maybe<Scalars['String']['output']>;
  datePlacedIntheGoodBin?: Maybe<Scalars['String']['output']>;
  datePlacedIntheLBIBin?: Maybe<Scalars['String']['output']>;
  datePlacedIntheUWBin?: Maybe<Scalars['String']['output']>;
  deviceCode?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  estimatedBatteryLife?: Maybe<Scalars['String']['output']>;
  hasActivityLevel: Scalars['Boolean']['output'];
  hasBRConfirmationState: Scalars['Boolean']['output'];
  hasBatteryBinRule: Scalars['Boolean']['output'];
  hasBatteryFailureMsg: Scalars['Boolean']['output'];
  hasBatteryReplacementIndication: Scalars['Boolean']['output'];
  hasBatteryReplacementOn: Scalars['Boolean']['output'];
  hasCActivityLevel: Scalars['Boolean']['output'];
  hasCurrentBatteryCapacity: Scalars['Boolean']['output'];
  hasDatePlacedIntheGoodBin: Scalars['Boolean']['output'];
  hasDatePlacedIntheLBIBin: Scalars['Boolean']['output'];
  hasDatePlacedIntheUWBin: Scalars['Boolean']['output'];
  hasDeviceCode: Scalars['Boolean']['output'];
  hasDeviceType: Scalars['Boolean']['output'];
  hasEstimatedBatteryLife: Scalars['Boolean']['output'];
  hasLBIDiffPlacedIntheGoodBin: Scalars['Boolean']['output'];
  hasLBIDiffPlacedIntheLBIBin: Scalars['Boolean']['output'];
  hasLBIDiffPlacedIntheUWBin: Scalars['Boolean']['output'];
  hasLBIValueIntheGoodBin: Scalars['Boolean']['output'];
  hasLBIValueIntheLBIBin: Scalars['Boolean']['output'];
  hasLBIValueIntheUWBin: Scalars['Boolean']['output'];
  hasLastScannedDate: Scalars['Boolean']['output'];
  hasPreviousBatteryCapacity: Scalars['Boolean']['output'];
  hasRemainingBatteryLife: Scalars['Boolean']['output'];
  lastScannedDate?: Maybe<Scalars['String']['output']>;
  lbiDiffPlacedIntheGoodBin?: Maybe<Scalars['String']['output']>;
  lbiDiffPlacedIntheLBIBin?: Maybe<Scalars['String']['output']>;
  lbiDiffPlacedIntheUWBin?: Maybe<Scalars['String']['output']>;
  lbiValueIntheGoodBin?: Maybe<Scalars['String']['output']>;
  lbiValueIntheLBIBin?: Maybe<Scalars['String']['output']>;
  lbiValueIntheUWBin?: Maybe<Scalars['String']['output']>;
  previousBatteryCapacity?: Maybe<Scalars['String']['output']>;
  remainingBatteryLife?: Maybe<Scalars['String']['output']>;
};

export type BleTagEventDtoInput = {
  eventType: Scalars['String']['input'];
  locAltitude: Scalars['String']['input'];
  locLat: Scalars['String']['input'];
  locLong: Scalars['String']['input'];
  locName: Scalars['String']['input'];
  locationType: Scalars['String']['input'];
  tagFirmware: Scalars['String']['input'];
  tagId: Scalars['String']['input'];
  tagKeys: Scalars['String']['input'];
  tagPressType: Scalars['String']['input'];
  tagType: Scalars['String']['input'];
  timeStamp: Scalars['String']['input'];
  transport: Scalars['String']['input'];
};

export type BooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Boundary = {
  __typename?: 'Boundary';
  coordinates: Array<Coordinate>;
  type: Scalars['String']['output'];
};

export type BoundaryCoordinate = {
  __typename?: 'BoundaryCoordinate';
  lat: Scalars['Float']['output'];
  lon: Scalars['Float']['output'];
};

export type BoundaryFilterInput = {
  and?: InputMaybe<Array<BoundaryFilterInput>>;
  coordinates?: InputMaybe<ListFilterInputTypeOfCoordinateFilterInput>;
  or?: InputMaybe<Array<BoundaryFilterInput>>;
  type?: InputMaybe<StringOperationFilterInput>;
};

export type BoundarySortInput = {
  type?: InputMaybe<SortEnumType>;
};

export type BtnPressAlertData = {
  __typename?: 'BtnPressAlertData';
  acceptedOn?: Maybe<Scalars['String']['output']>;
  alertId?: Maybe<Scalars['String']['output']>;
  alertStateTypeId: Scalars['Int']['output'];
  alertStatusMessage?: Maybe<AlertStatusMessage>;
  altitude?: Maybe<Scalars['String']['output']>;
  buildingId?: Maybe<Scalars['String']['output']>;
  buildingName?: Maybe<Scalars['String']['output']>;
  calculateSize: Scalars['Int']['output'];
  campusName?: Maybe<Scalars['String']['output']>;
  campuseId?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clone?: Maybe<BtnPressAlertData>;
  closedOn?: Maybe<Scalars['String']['output']>;
  createdOn?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  escalationId?: Maybe<Scalars['String']['output']>;
  escalationLevel: Scalars['Int']['output'];
  floorId?: Maybe<Scalars['String']['output']>;
  floorName?: Maybe<Scalars['String']['output']>;
  hasLastEventTypeId: Scalars['Boolean']['output'];
  lastEventTypeId: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  locationType?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  playAudio?: Maybe<Scalars['String']['output']>;
  responseTime?: Maybe<Scalars['String']['output']>;
  roomId?: Maybe<Scalars['String']['output']>;
  roomName?: Maybe<Scalars['String']['output']>;
  staffFirstName?: Maybe<Scalars['String']['output']>;
  staffId?: Maybe<Scalars['String']['output']>;
  staffLastName?: Maybe<Scalars['String']['output']>;
  tagId?: Maybe<Scalars['String']['output']>;
};

export type BulkCreateAlertConditionEmItemInput = {
  alertEmItems: Array<CreateAlertConditionEmItemInput>;
};

export type BulkCreateAlertRecipientInput = {
  alertRecipients: Array<CreateAlertRecipientInput>;
};

export type BulkUpdateAlertRecipientInput = {
  alertRecipients: Array<UpdateAlertRecipientInput>;
};

export type CaBoundary = {
  __typename?: 'CABoundary';
  coordinates: Array<BoundaryCoordinate>;
  type: Scalars['String']['output'];
};

export type CaBuilding = {
  __typename?: 'CABuilding';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  site_id: Scalars['String']['output'];
  toJson: Scalars['String']['output'];
};

export type CaCountModel = {
  __typename?: 'CACountModel';
  count: Scalars['Int']['output'];
};

export type CaCustomer = {
  __typename?: 'CACustomer';
  aliasName?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  licenseInfo: LicenseInfo;
  subdomain: Scalars['String']['output'];
};

export type CaDepartment = {
  __typename?: 'CADepartment';
  caSite?: Maybe<CaSite>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  siteId: Scalars['String']['output'];
};

export type CaDepartmentFilterInput = {
  and?: InputMaybe<Array<CaDepartmentFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CaDepartmentFilterInput>>;
  siteId?: InputMaybe<StringOperationFilterInput>;
};

export type CaDepartmentShift = {
  __typename?: 'CADepartmentShift';
  departmentId: Scalars['Int']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type CaDepartmentSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  siteId?: InputMaybe<SortEnumType>;
};

export type CaFloor = {
  __typename?: 'CAFloor';
  building_id?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  site_id: Scalars['String']['output'];
  sub_building_id?: Maybe<Scalars['Int']['output']>;
  toJson: Scalars['String']['output'];
};

export type CaFloorList = {
  __typename?: 'CAFloorList';
  buildingId: Scalars['Int']['output'];
  buildingName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  siteId: Scalars['Int']['output'];
  siteLinkId: Scalars['Int']['output'];
  siteName: Scalars['String']['output'];
  subBuildingId: Scalars['Int']['output'];
  subBuildingName: Scalars['String']['output'];
  type: FloorType;
};

export type CaFloorListFilterInput = {
  and?: InputMaybe<Array<CaFloorListFilterInput>>;
  buildingId?: InputMaybe<IntOperationFilterInput>;
  buildingName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CaFloorListFilterInput>>;
  siteId?: InputMaybe<IntOperationFilterInput>;
  siteLinkId?: InputMaybe<IntOperationFilterInput>;
  siteName?: InputMaybe<StringOperationFilterInput>;
  subBuildingId?: InputMaybe<IntOperationFilterInput>;
  subBuildingName?: InputMaybe<StringOperationFilterInput>;
  type?: InputMaybe<FloorTypeOperationFilterInput>;
};

export type CaFloorListSortInput = {
  buildingId?: InputMaybe<SortEnumType>;
  buildingName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  siteId?: InputMaybe<SortEnumType>;
  siteLinkId?: InputMaybe<SortEnumType>;
  siteName?: InputMaybe<SortEnumType>;
  subBuildingId?: InputMaybe<SortEnumType>;
  subBuildingName?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export type CaLocation = {
  __typename?: 'CALocation';
  aliasName?: Maybe<Scalars['String']['output']>;
  boundary?: Maybe<CaBoundary>;
  buildingId?: Maybe<Scalars['Int']['output']>;
  floorId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  is_zone?: Maybe<Scalars['Boolean']['output']>;
  locationGroup?: Maybe<CaLocationGroup>;
  locationType: CaLocationType;
  locationTypeId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  sensorValues?: Maybe<Scalars['String']['output']>;
  siteId: Scalars['Int']['output'];
};

export type CaLocationData = {
  __typename?: 'CALocationData';
  assetLocationTypeId: Scalars['Int']['output'];
  departmentName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locationTypeId: Scalars['Int']['output'];
  locationTypeName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  siteId: Scalars['Int']['output'];
  siteName: Scalars['String']['output'];
};

export type CaLocationDataFilterInput = {
  and?: InputMaybe<Array<CaLocationDataFilterInput>>;
  assetLocationTypeId?: InputMaybe<IntOperationFilterInput>;
  departmentName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  locationTypeId?: InputMaybe<IntOperationFilterInput>;
  locationTypeName?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CaLocationDataFilterInput>>;
  siteId?: InputMaybe<IntOperationFilterInput>;
  siteName?: InputMaybe<StringOperationFilterInput>;
};

export type CaLocationGroup = {
  __typename?: 'CALocationGroup';
  locationGroupId: Scalars['Int']['output'];
  locationGroupName: Scalars['String']['output'];
};

export type CaLocationStatus = {
  __typename?: 'CALocationStatus';
  id: Scalars['Int']['output'];
  location_status_color?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type CaLocationType = {
  __typename?: 'CALocationType';
  name: Scalars['String']['output'];
};

export type CaLocationTypeInfo = {
  __typename?: 'CALocationTypeInfo';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CaSensor = {
  __typename?: 'CASensor';
  customer_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  location?: Maybe<CaLocation>;
  location_id: Scalars['Int']['output'];
  rtls_vendor_id: Scalars['String']['output'];
  sensor_type_id: Scalars['Int']['output'];
  sensor_value: Scalars['String']['output'];
};

export type CaSite = {
  __typename?: 'CASite';
  default_timezone: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  toJson: Scalars['String']['output'];
};

export type CaStaff = {
  __typename?: 'CAStaff';
  departments: Array<CaStaffDepartment>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type CaStaffDepartment = {
  __typename?: 'CAStaffDepartment';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type CaStaffInfoCount = {
  __typename?: 'CAStaffInfoCount';
  count: Scalars['Int']['output'];
};

export type CaStaffList = {
  __typename?: 'CAStaffList';
  createdUtc: Scalars['String']['output'];
  department: Scalars['String']['output'];
  departmentIds: Array<Scalars['Int']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentRole: Scalars['String']['output'];
  role: Scalars['String']['output'];
  roleId: Scalars['Int']['output'];
  securedStaffName: Scalars['String']['output'];
  tagId: Scalars['String']['output'];
};

export type CaStaffListFilterInput = {
  and?: InputMaybe<Array<CaStaffListFilterInput>>;
  createdUtc?: InputMaybe<StringOperationFilterInput>;
  department?: InputMaybe<StringOperationFilterInput>;
  departmentIds?: InputMaybe<ListIntOperationFilterInput>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<CaStaffListFilterInput>>;
  parentRole?: InputMaybe<StringOperationFilterInput>;
  role?: InputMaybe<StringOperationFilterInput>;
  roleId?: InputMaybe<IntOperationFilterInput>;
  securedStaffName?: InputMaybe<StringOperationFilterInput>;
  tagId?: InputMaybe<StringOperationFilterInput>;
};

export type CaStaffListSortInput = {
  createdUtc?: InputMaybe<SortEnumType>;
  department?: InputMaybe<SortEnumType>;
  firstName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastName?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parentRole?: InputMaybe<SortEnumType>;
  role?: InputMaybe<SortEnumType>;
  roleId?: InputMaybe<SortEnumType>;
  securedStaffName?: InputMaybe<SortEnumType>;
  tagId?: InputMaybe<SortEnumType>;
};

export type CaStaffType = {
  __typename?: 'CAStaffType';
  icon?: Maybe<CaStaffTypeIconStyleModel>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  parent_staff_type?: Maybe<CaStaffType>;
  parent_staff_type_id?: Maybe<Scalars['Int']['output']>;
};

export type CaStaffTypeIconStyleModel = {
  __typename?: 'CAStaffTypeIconStyleModel';
  icon_acronym?: Maybe<Scalars['String']['output']>;
  icon_color: Scalars['String']['output'];
  icon_name: Scalars['String']['output'];
  id: Scalars['String']['output'];
  staff_type_id: Scalars['Int']['output'];
};

export type CaSubBuilding = {
  __typename?: 'CASubBuilding';
  building_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  site_id: Scalars['String']['output'];
  toJson: Scalars['String']['output'];
};

export type CaTag = {
  __typename?: 'CATag';
  id: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  tag_value: Scalars['String']['output'];
};

export type CaUser = {
  __typename?: 'CAUser';
  customerId: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  preferences?: Maybe<Scalars['Any']['output']>;
};

/** Information about the offset pagination. */
export type CollectionSegmentInfo = {
  __typename?: 'CollectionSegmentInfo';
  /** Indicates whether more items exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more items exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type Coordinate = {
  __typename?: 'Coordinate';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type CoordinateFilterInput = {
  and?: InputMaybe<Array<CoordinateFilterInput>>;
  lat?: InputMaybe<FloatOperationFilterInput>;
  lng?: InputMaybe<FloatOperationFilterInput>;
  or?: InputMaybe<Array<CoordinateFilterInput>>;
};

export type Coordinates = {
  __typename?: 'Coordinates';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<Coordinates>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CreateAlertConditionEmItemInput = {
  alertConditionId: Scalars['String']['input'];
  emItemId: Scalars['String']['input'];
};

export type CreateAlertConditionInput = {
  allowUserToSpecifyReopenTime?: InputMaybe<Scalars['Boolean']['input']>;
  autoResponseEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoResponseMessage?: InputMaybe<Scalars['String']['input']>;
  autoResponseTimeMin?: InputMaybe<Scalars['Int']['input']>;
  emItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  maxValue: Scalars['Int']['input'];
  minValue: Scalars['Int']['input'];
  probeTypeId: Scalars['String']['input'];
  recipientGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reopenIfOutOfRangeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reopenTimeMin?: InputMaybe<Scalars['Int']['input']>;
  repeatDelayMin?: InputMaybe<Scalars['Int']['input']>;
  repeatMode?: InputMaybe<Scalars['String']['input']>;
  rollingAvgTriggerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export type CreateAlertInput = {
  acknowledgedBy?: InputMaybe<Scalars['String']['input']>;
  alertConditionId: Scalars['String']['input'];
  emItemId: Scalars['String']['input'];
  probeId: Scalars['String']['input'];
  status: Scalars['String']['input'];
  valueSnapshot: Scalars['Int']['input'];
};

export type CreateAlertRecipientInput = {
  alertConditionId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  recipientGroupId?: InputMaybe<Scalars['String']['input']>;
  reportAfterMin?: InputMaybe<Scalars['Int']['input']>;
  staffId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAlertResponseInput = {
  alertId: Scalars['String']['input'];
  createdBy?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
};

export type CreateAuthConfigInput = {
  authConfig: Scalars['String']['input'];
  authType: Scalars['String']['input'];
  encoding: TemplateBodyEncoding;
  name: Scalars['String']['input'];
};

export type CreateEmItemGroupInput = {
  name: Scalars['String']['input'];
};

export type CreateEmItemInput = {
  customId?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  emItemTypeId?: InputMaybe<Scalars['String']['input']>;
  firstCheckTime?: InputMaybe<Scalars['String']['input']>;
  historicalSaveRate?: InputMaybe<Scalars['Int']['input']>;
  inMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  secondCheckTime?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEmItemTypeInput = {
  name: Scalars['String']['input'];
};

export type CreateEmTagInput = {
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  tagValue: Scalars['String']['input'];
};

export type CreateHhRuleDtoInput = {
  caLocationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  caLocationTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  caStaffTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  departmentId: Scalars['String']['input'];
  entryDispenserTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  entryEnabled: Scalars['Boolean']['input'];
  entrySecondsToRemainInTheRoom?: InputMaybe<Scalars['Int']['input']>;
  entrySecondsToRemainOutOfTheRoom?: InputMaybe<Scalars['Int']['input']>;
  exitDispenserTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  exitEnabled: Scalars['Boolean']['input'];
  exitSecondsToRemainInTheRoom?: InputMaybe<Scalars['Int']['input']>;
  exitSecondsToRemainOutOfTheRoom?: InputMaybe<Scalars['Int']['input']>;
  hhLocationTypeId?: InputMaybe<Scalars['Int']['input']>;
  messageGroupIds: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  precautionId?: InputMaybe<Scalars['Int']['input']>;
  secondsToWashAfterEnterTheRoom?: InputMaybe<Scalars['Int']['input']>;
  secondsToWashAfterExitTheRoom?: InputMaybe<Scalars['Int']['input']>;
  secondsToWashBeforeEnterTheRoom?: InputMaybe<Scalars['Int']['input']>;
  secondsToWashBeforeExitTheRoom?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateIntegrationConfigInput = {
  authConfigId?: InputMaybe<Scalars['String']['input']>;
  encoding: TemplateBodyEncoding;
  endpointUrl: Scalars['String']['input'];
  httpMethod?: InputMaybe<Scalars['String']['input']>;
  internalEventId: Scalars['String']['input'];
  intervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  requestHeaders: Scalars['String']['input'];
  schedule?: InputMaybe<Array<Scalars['String']['input']>>;
  sftpFilePath?: InputMaybe<Scalars['String']['input']>;
  sourceType: Scalars['String']['input'];
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIrtIncomingWorkflowInput = {
  direction?: InputMaybe<Scalars['String']['input']>;
  encoding?: InputMaybe<TemplateBodyEncoding>;
  graph: Scalars['String']['input'];
  intervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  schedule?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateIrtOutgoingWorkflowInput = {
  direction?: InputMaybe<Scalars['String']['input']>;
  encoding?: InputMaybe<TemplateBodyEncoding>;
  graph: Scalars['String']['input'];
  intervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  schedule?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateMappingTemplateInput = {
  internalEventId: Scalars['String']['input'];
  mapping: Scalars['String']['input'];
  mappingEncoding: TemplateBodyEncoding;
  name: Scalars['String']['input'];
};

export type CreateOutboundConfigInput = {
  authConfigId?: InputMaybe<Scalars['String']['input']>;
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  encoding: TemplateBodyEncoding;
  headers?: InputMaybe<Scalars['String']['input']>;
  httpMethod?: InputMaybe<Scalars['String']['input']>;
  internalEventId: Scalars['String']['input'];
  intervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  schedule?: InputMaybe<Array<Scalars['String']['input']>>;
  templateId: Scalars['String']['input'];
  transportType?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type CreateProbeInput = {
  emItemId: Scalars['String']['input'];
  emTagId: Scalars['String']['input'];
  externalProbeId: Scalars['String']['input'];
  probeTypeId: Scalars['String']['input'];
};

export type CreateProbeTypeInput = {
  conversionIntercept?: InputMaybe<Scalars['Float']['input']>;
  conversionSlope?: InputMaybe<Scalars['Float']['input']>;
  displayUnits?: InputMaybe<Scalars['String']['input']>;
  displayWordUnits?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  suffix?: InputMaybe<Scalars['String']['input']>;
  unitsReceived?: InputMaybe<Scalars['String']['input']>;
  unitsToStore?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRecipientGroupInput = {
  caDepartmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  outboundType?: InputMaybe<Array<Scalars['Int']['input']>>;
  recipients?: InputMaybe<Array<RecipientGroupRecipientInput>>;
  title: Scalars['String']['input'];
};

export type CreateTemplateInput = {
  body: Scalars['String']['input'];
  bodyEncoding: TemplateBodyEncoding;
  internalEventId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type DateOperationFilterInput = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  neq?: InputMaybe<Scalars['Date']['input']>;
  ngt?: InputMaybe<Scalars['Date']['input']>;
  ngte?: InputMaybe<Scalars['Date']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Date']['input']>>>;
  nlt?: InputMaybe<Scalars['Date']['input']>;
  nlte?: InputMaybe<Scalars['Date']['input']>;
};

export type DateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  neq?: InputMaybe<Scalars['DateTime']['input']>;
  ngt?: InputMaybe<Scalars['DateTime']['input']>;
  ngte?: InputMaybe<Scalars['DateTime']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  nlt?: InputMaybe<Scalars['DateTime']['input']>;
  nlte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DefaultMsgReplyCount = {
  __typename?: 'DefaultMsgReplyCount';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<DefaultMsgReplyCount>;
  count: Scalars['Int']['output'];
};

export type DefaultRespondMessage = {
  __typename?: 'DefaultRespondMessage';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<DefaultRespondMessage>;
  msgId: Scalars['Int']['output'];
  priorityId: Scalars['Int']['output'];
  respondMessage?: Maybe<Scalars['String']['output']>;
};

export type DeleteEscalationDtoInput = {
  escalationId: Scalars['String']['input'];
};

export type DeleteOutboundMsgDtoInput = {
  groupId: Scalars['String']['input'];
};

export type DeleteRespondMsgDtoInput = {
  msgId: Scalars['Int']['input'];
};

export type DeleteRespondReply = {
  __typename?: 'DeleteRespondReply';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<DeleteRespondReply>;
  response: Scalars['Boolean']['output'];
};

export type DeleteRuleDtoInput = {
  ruleId: Scalars['Int']['input'];
};

export type DeleteStatusUpdateMsgDtoInput = {
  statusUpdateId: Scalars['String']['input'];
};

export type DeleteStatusUpdateReply = {
  __typename?: 'DeleteStatusUpdateReply';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<DeleteStatusUpdateReply>;
  response: Scalars['Boolean']['output'];
};

export type DepartmentList = {
  __typename?: 'DepartmentList';
  ownerDepartmentText: Scalars['String']['output'];
  ownerDepartmentValue: Scalars['String']['output'];
};

export type DeviceModel = {
  __typename?: 'DeviceModel';
  altitude: Scalars['Int']['output'];
  battery?: Maybe<BatteryStatusModel>;
  calculateSize: Scalars['Int']['output'];
  clientId: Scalars['Int']['output'];
  clone?: Maybe<DeviceModel>;
  coordinates?: Maybe<Coordinates>;
  deviceCode?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  firstSeen: Scalars['Long']['output'];
  modelItem?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type DuressAction = {
  __typename?: 'DuressAction';
  actionTaken?: Maybe<Scalars['String']['output']>;
  altitude?: Maybe<Scalars['String']['output']>;
  buildingId?: Maybe<Scalars['String']['output']>;
  buildingName?: Maybe<Scalars['String']['output']>;
  calculateSize: Scalars['Int']['output'];
  campusId?: Maybe<Scalars['String']['output']>;
  campusName?: Maybe<Scalars['String']['output']>;
  clone?: Maybe<DuressAction>;
  date?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  floorId?: Maybe<Scalars['String']['output']>;
  floorName?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  responseTime?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  staffFirstName?: Maybe<Scalars['String']['output']>;
  staffLastName?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
};

export type DuressAlert = {
  __typename?: 'DuressAlert';
  acceptedOn?: Maybe<Scalars['String']['output']>;
  actionBy?: Maybe<Scalars['String']['output']>;
  alertId?: Maybe<Scalars['String']['output']>;
  alertStateTypeId: Scalars['Int']['output'];
  altitude?: Maybe<Scalars['String']['output']>;
  buildingId?: Maybe<Scalars['String']['output']>;
  buildingName?: Maybe<Scalars['String']['output']>;
  calculateSize: Scalars['Int']['output'];
  campusId?: Maybe<Scalars['String']['output']>;
  campusName?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  clone?: Maybe<DuressAlert>;
  closedOn?: Maybe<Scalars['String']['output']>;
  createdOn?: Maybe<Scalars['String']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  deviceName?: Maybe<Scalars['String']['output']>;
  escalationId?: Maybe<Scalars['String']['output']>;
  escalationLevel: Scalars['Int']['output'];
  floorId?: Maybe<Scalars['String']['output']>;
  floorName?: Maybe<Scalars['String']['output']>;
  hasLastEventTypeId: Scalars['Boolean']['output'];
  lastEventTypeId: Scalars['Int']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  locationType?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  playAudio?: Maybe<Scalars['String']['output']>;
  responseTime?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  roomId?: Maybe<Scalars['String']['output']>;
  roomName?: Maybe<Scalars['String']['output']>;
  staffFirstName?: Maybe<Scalars['String']['output']>;
  staffId?: Maybe<Scalars['String']['output']>;
  staffLastName?: Maybe<Scalars['String']['output']>;
  statusMessages?: Maybe<Array<Maybe<StatusMessage>>>;
  tagId?: Maybe<Scalars['String']['output']>;
};

export type DuressCountModel = {
  __typename?: 'DuressCountModel';
  count: Scalars['Int']['output'];
};

export type DuressReportConfiguration = {
  __typename?: 'DuressReportConfiguration';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<DuressReportConfiguration>;
  hasQSearchUrl: Scalars['Boolean']['output'];
  qSearchUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DuressStaff = {
  __typename?: 'DuressStaff';
  binStatus: Scalars['String']['output'];
  createdUtc: Scalars['String']['output'];
  department: Scalars['String']['output'];
  departmentIds: Array<Scalars['Int']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  parentRole: Scalars['String']['output'];
  role: Scalars['String']['output'];
  roleId: Scalars['Int']['output'];
  securedStaffName: Scalars['String']['output'];
  tagId: Scalars['String']['output'];
};

export type EmItemDto = {
  __typename?: 'EMItemDto';
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  customId?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  department?: Maybe<CaDepartment>;
  departmentId?: Maybe<Scalars['Int']['output']>;
  emItemType?: Maybe<EmItemTypeDto>;
  emItemTypeId: Scalars['String']['output'];
  firstCheckTime?: Maybe<Scalars['String']['output']>;
  historicalSaveRate?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  inMaintenance?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<CaLocation>;
  locationId?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  probes: Array<ProbeDto>;
  secondCheckTime?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type EmItemGroupDto = {
  __typename?: 'EMItemGroupDto';
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type EmItemTypeDto = {
  __typename?: 'EMItemTypeDto';
  createdBy?: Maybe<Scalars['String']['output']>;
  createdUtc: Scalars['DateTime']['output'];
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type EmTagDto = {
  __typename?: 'EMTagDto';
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  probes: Array<ProbeDto>;
  tagValue: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export enum EOrderNullsType {
  NullsFirst = 'NULLS_FIRST',
  NullsLast = 'NULLS_LAST'
}

export enum EOrderType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type EscalationDepartmentCustomInput = {
  triggerDepartmentId: Scalars['Int']['input'];
};

export type EscalationLevelCustomInput = {
  escalationLevelEnable: Scalars['Boolean']['input'];
  escalationLevelGroups: Array<EscalationLevelGroupCustomInput>;
  escalationLevelName: Scalars['String']['input'];
  level: Scalars['Int']['input'];
  nextLevelescalationTime: Scalars['Int']['input'];
};

export type EscalationLevelGroupCustomInput = {
  messageGroupId: Scalars['String']['input'];
};

export type EventDto = {
  __typename?: 'EventDto';
  endpoint?: Maybe<Scalars['String']['output']>;
  eventTypeId?: Maybe<Scalars['String']['output']>;
};

export type EventFilteringDtoInput = {
  alertStateTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  buildingIds?: InputMaybe<Array<Scalars['String']['input']>>;
  departmentNames?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  floorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  siteIds?: InputMaybe<Array<Scalars['String']['input']>>;
  staffIds?: InputMaybe<Array<Scalars['String']['input']>>;
  staffName?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EventResponseDto = {
  __typename?: 'EventResponseDto';
  eventDescription?: Maybe<Scalars['String']['output']>;
  eventTypeId: Scalars['UUID']['output'];
  msgVersion?: Maybe<Scalars['String']['output']>;
  senderOrReceiverEvent?: Maybe<Scalars['String']['output']>;
};

export type ExtractSearchStateResponse = {
  __typename?: 'ExtractSearchStateResponse';
  areaDepartment?: Maybe<Scalars['Int']['output']>;
  assetGroup?: Maybe<Scalars['String']['output']>;
  assetLocationTypeId?: Maybe<Scalars['Int']['output']>;
  assetType?: Maybe<Scalars['String']['output']>;
  batteryStatus?: Maybe<BatteryStatus>;
  floor?: Maybe<Scalars['Int']['output']>;
  search: Scalars['String']['output'];
};

export type FloatOperationFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
  ngt?: InputMaybe<Scalars['Float']['input']>;
  ngte?: InputMaybe<Scalars['Float']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  nlt?: InputMaybe<Scalars['Float']['input']>;
  nlte?: InputMaybe<Scalars['Float']['input']>;
};

export type FloorTagInfoRequestInput = {
  floor?: InputMaybe<Scalars['String']['input']>;
};

export type FloorTagReplyModel = {
  __typename?: 'FloorTagReplyModel';
  altitude?: Maybe<Scalars['Float']['output']>;
  assignee?: Maybe<Scalars['String']['output']>;
  assigneedName?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['String']['output'];
  floor?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  locationType: Scalars['String']['output'];
  locationValue: Scalars['String']['output'];
  longitude?: Maybe<Scalars['Float']['output']>;
  patient?: Maybe<AssignedPatient>;
  staff?: Maybe<AssignedStaff>;
  tag_value: Scalars['String']['output'];
  time: Scalars['String']['output'];
};

export enum FloorType {
  Building = 'BUILDING',
  Floor = 'FLOOR',
  Site = 'SITE',
  Subbuilding = 'SUBBUILDING'
}

export type FloorTypeOperationFilterInput = {
  eq?: InputMaybe<FloorType>;
  in?: InputMaybe<Array<FloorType>>;
  neq?: InputMaybe<FloorType>;
  nin?: InputMaybe<Array<FloorType>>;
};

export type GetEscalationDtoInput = {
  escalationId: Scalars['String']['input'];
};

export type GetEscalationFilterDtoInput = {
  escalationId: Scalars['String']['input'];
};

export type GetOutboundMsgDtoInput = {
  groupId: Scalars['String']['input'];
};

export type GetOutboundMsgFilterDtoInput = {
  groupId: Scalars['String']['input'];
};

export type GetRuleDtoInput = {
  ruleId: Scalars['Int']['input'];
};

export type GetRulesDepartmentFilterDtoInput = {
  keyBitDecimal: Scalars['Int']['input'];
  ruleId: Scalars['Int']['input'];
};

export type GetRulesFilterDtoInput = {
  ruleId: Scalars['Int']['input'];
};

export type HhActivity = {
  __typename?: 'HHActivity';
  activityDate: Scalars['DateTime']['output'];
  activityEvent: Scalars['String']['output'];
  activityId: Scalars['String']['output'];
  aliasName?: Maybe<Scalars['String']['output']>;
  customerId: Scalars['Int']['output'];
  departmentId: Scalars['String']['output'];
  departmentName: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  deviceName: Scalars['String']['output'];
  dispenserTypeId: Scalars['String']['output'];
  dispenserTypeName: Scalars['String']['output'];
  floorId?: Maybe<Scalars['Int']['output']>;
  hhLocationTypeId: Scalars['String']['output'];
  hhLocationTypeName: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  locationTypeId: Scalars['String']['output'];
  locationTypeName: Scalars['String']['output'];
  precautionId: Scalars['String']['output'];
  precautionName: Scalars['String']['output'];
  ruleId: Scalars['String']['output'];
  ruleName: Scalars['String']['output'];
  staffFirstName: Scalars['String']['output'];
  staffId: Scalars['String']['output'];
  staffLastName: Scalars['String']['output'];
  staffTypeId: Scalars['String']['output'];
  staffTypeName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tagValue?: Maybe<Scalars['String']['output']>;
};

export type HhActivityFilterInput = {
  activityDate?: InputMaybe<DateTimeOperationFilterInput>;
  activityEvent?: InputMaybe<StringOperationFilterInput>;
  activityId?: InputMaybe<StringOperationFilterInput>;
  aliasName?: InputMaybe<StringOperationFilterInput>;
  and?: InputMaybe<Array<HhActivityFilterInput>>;
  customerId?: InputMaybe<IntOperationFilterInput>;
  departmentId?: InputMaybe<StringOperationFilterInput>;
  departmentName?: InputMaybe<StringOperationFilterInput>;
  deviceId?: InputMaybe<StringOperationFilterInput>;
  deviceName?: InputMaybe<StringOperationFilterInput>;
  dispenserTypeId?: InputMaybe<StringOperationFilterInput>;
  dispenserTypeName?: InputMaybe<StringOperationFilterInput>;
  floorId?: InputMaybe<IntOperationFilterInput>;
  hhLocationTypeId?: InputMaybe<StringOperationFilterInput>;
  hhLocationTypeName?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  locationTypeId?: InputMaybe<StringOperationFilterInput>;
  locationTypeName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<HhActivityFilterInput>>;
  precautionId?: InputMaybe<StringOperationFilterInput>;
  precautionName?: InputMaybe<StringOperationFilterInput>;
  ruleId?: InputMaybe<StringOperationFilterInput>;
  ruleName?: InputMaybe<StringOperationFilterInput>;
  staffFirstName?: InputMaybe<StringOperationFilterInput>;
  staffId?: InputMaybe<StringOperationFilterInput>;
  staffLastName?: InputMaybe<StringOperationFilterInput>;
  staffTypeId?: InputMaybe<StringOperationFilterInput>;
  staffTypeName?: InputMaybe<StringOperationFilterInput>;
  status?: InputMaybe<StringOperationFilterInput>;
  tagValue?: InputMaybe<StringOperationFilterInput>;
};

export type HhActivityMilestone = {
  __typename?: 'HHActivityMilestone';
  createdUtc: Scalars['DateTime']['output'];
  customerId: Scalars['Int']['output'];
  deviceId?: Maybe<Scalars['String']['output']>;
  dispenserName?: Maybe<Scalars['String']['output']>;
  dispenserTypeId?: Maybe<Scalars['String']['output']>;
  dispenserTypeName?: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  id: Scalars['String']['output'];
  locationId: Scalars['Int']['output'];
  locationName: Scalars['String']['output'];
  locationTypeId: Scalars['Int']['output'];
  locationTypeName: Scalars['String']['output'];
  precautionId?: Maybe<Scalars['Int']['output']>;
  precautionName?: Maybe<Scalars['String']['output']>;
  sensorValue: Scalars['String']['output'];
  staffFirstName: Scalars['String']['output'];
  staffId: Scalars['Int']['output'];
  staffLastName: Scalars['String']['output'];
  staffTypeId: Scalars['Int']['output'];
  staffTypeName: Scalars['String']['output'];
  tagValue: Scalars['String']['output'];
  time: Scalars['DateTime']['output'];
  toJson: Scalars['String']['output'];
};

export type HhActivitySortInput = {
  activityDate?: InputMaybe<SortEnumType>;
  activityEvent?: InputMaybe<SortEnumType>;
  activityId?: InputMaybe<SortEnumType>;
  aliasName?: InputMaybe<SortEnumType>;
  customerId?: InputMaybe<SortEnumType>;
  departmentId?: InputMaybe<SortEnumType>;
  departmentName?: InputMaybe<SortEnumType>;
  deviceId?: InputMaybe<SortEnumType>;
  deviceName?: InputMaybe<SortEnumType>;
  dispenserTypeId?: InputMaybe<SortEnumType>;
  dispenserTypeName?: InputMaybe<SortEnumType>;
  floorId?: InputMaybe<SortEnumType>;
  hhLocationTypeId?: InputMaybe<SortEnumType>;
  hhLocationTypeName?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<SortEnumType>;
  locationTypeId?: InputMaybe<SortEnumType>;
  locationTypeName?: InputMaybe<SortEnumType>;
  precautionId?: InputMaybe<SortEnumType>;
  precautionName?: InputMaybe<SortEnumType>;
  ruleId?: InputMaybe<SortEnumType>;
  ruleName?: InputMaybe<SortEnumType>;
  staffFirstName?: InputMaybe<SortEnumType>;
  staffId?: InputMaybe<SortEnumType>;
  staffLastName?: InputMaybe<SortEnumType>;
  staffTypeId?: InputMaybe<SortEnumType>;
  staffTypeName?: InputMaybe<SortEnumType>;
  status?: InputMaybe<SortEnumType>;
  tagValue?: InputMaybe<SortEnumType>;
};

export type HhCountModel = {
  __typename?: 'HHCountModel';
  count: Scalars['Int']['output'];
};

export type HhDepartment = {
  __typename?: 'HHDepartment';
  caDepartmentId: Scalars['Int']['output'];
  caDepartmentName: Scalars['String']['output'];
  caSiteId: Scalars['Int']['output'];
  caSiteName: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  customerId: Scalars['Int']['output'];
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  minTargetCompliance: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
  toJson: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type HhDevice = {
  __typename?: 'HHDevice';
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  customerId: Scalars['Int']['output'];
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  deviceId: Scalars['String']['output'];
  deviceName?: Maybe<Scalars['String']['output']>;
  dispenserType?: Maybe<HhDispenserType>;
  dispenserTypeId?: Maybe<Scalars['Int']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  sensorId: Scalars['Int']['output'];
  sensorValue: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type HhDispenserType = {
  __typename?: 'HHDispenserType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type HhEvent = {
  __typename?: 'HHEvent';
  activityDate: Scalars['DateTime']['output'];
  activityEvent: Scalars['String']['output'];
  activityId: Scalars['String']['output'];
  aliasName?: Maybe<Scalars['String']['output']>;
  departmentId: Scalars['String']['output'];
  departmentName: Scalars['String']['output'];
  deviceId: Scalars['String']['output'];
  deviceName: Scalars['String']['output'];
  dispenserTypeId: Scalars['String']['output'];
  dispenserTypeName: Scalars['String']['output'];
  floorId?: Maybe<Scalars['Int']['output']>;
  hhLocationTypeId: Scalars['String']['output'];
  hhLocationTypeName: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  locationTypeId: Scalars['String']['output'];
  locationTypeName: Scalars['String']['output'];
  precautionId: Scalars['String']['output'];
  precautionName: Scalars['String']['output'];
  ruleId: Scalars['String']['output'];
  ruleName: Scalars['String']['output'];
  staffFirstName: Scalars['String']['output'];
  staffId: Scalars['String']['output'];
  staffLastName: Scalars['String']['output'];
  staffTypeId: Scalars['String']['output'];
  staffTypeName: Scalars['String']['output'];
  status: Scalars['String']['output'];
  toJson: Scalars['String']['output'];
};

export type HhLocation = {
  __typename?: 'HHLocation';
  caLocationId: Scalars['Int']['output'];
  customerId: Scalars['Int']['output'];
  locationId: Scalars['String']['output'];
  precautionId?: Maybe<Scalars['Int']['output']>;
};

export type HhLocationType = {
  __typename?: 'HHLocationType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type HhMessageGroup = {
  __typename?: 'HHMessageGroup';
  caDepartmentIds?: Maybe<Array<Scalars['Int']['output']>>;
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  customerId: Scalars['Int']['output'];
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  groupName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  outboundType?: Maybe<Array<Scalars['Int']['output']>>;
  staffIds?: Maybe<Array<Scalars['Int']['output']>>;
  toJson: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type HhPrecaution = {
  __typename?: 'HHPrecaution';
  iconAcronym: Scalars['String']['output'];
  iconColor: Scalars['String']['output'];
  precautionId: Scalars['Int']['output'];
  precautionName: Scalars['String']['output'];
};

export type HhReportConfiguration = {
  __typename?: 'HHReportConfiguration';
  url: Scalars['String']['output'];
};

export type HhRule = {
  __typename?: 'HHRule';
  caLocationIds?: Maybe<Array<Scalars['Int']['output']>>;
  caLocationTypeIds?: Maybe<Array<Scalars['Int']['output']>>;
  caStaffTypeIds?: Maybe<Array<Scalars['Int']['output']>>;
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  customerId: Scalars['Int']['output'];
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  departmentId: Scalars['String']['output'];
  entryDispenserTypeIds?: Maybe<Array<Scalars['Int']['output']>>;
  entryEnabled: Scalars['Boolean']['output'];
  entrySecondsToRemainInTheRoom?: Maybe<Scalars['Int']['output']>;
  entrySecondsToRemainOutOfTheRoom?: Maybe<Scalars['Int']['output']>;
  exitDispenserTypeIds?: Maybe<Array<Scalars['Int']['output']>>;
  exitEnabled: Scalars['Boolean']['output'];
  exitSecondsToRemainInTheRoom?: Maybe<Scalars['Int']['output']>;
  exitSecondsToRemainOutOfTheRoom?: Maybe<Scalars['Int']['output']>;
  hhLocationTypeId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  messageGroupIds?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  precautionId?: Maybe<Scalars['Int']['output']>;
  secondsToWashAfterEnterTheRoom?: Maybe<Scalars['Int']['output']>;
  secondsToWashAfterExitTheRoom?: Maybe<Scalars['Int']['output']>;
  secondsToWashBeforeEnterTheRoom?: Maybe<Scalars['Int']['output']>;
  secondsToWashBeforeExitTheRoom?: Maybe<Scalars['Int']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type HhStaffCompliance = {
  __typename?: 'HHStaffCompliance';
  currentShift: Scalars['Int']['output'];
  departmentId: Scalars['String']['output'];
  previousShift: Scalars['Int']['output'];
  staffComplianceId: Scalars['String']['output'];
  staffType: Scalars['String']['output'];
  staffTypeId: Scalars['Int']['output'];
  totalOpportunities: Scalars['Int']['output'];
  totalWashes: Scalars['Int']['output'];
};

export type HhStaffComplianceFilterInput = {
  and?: InputMaybe<Array<HhStaffComplianceFilterInput>>;
  currentShift?: InputMaybe<IntOperationFilterInput>;
  departmentId?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<HhStaffComplianceFilterInput>>;
  previousShift?: InputMaybe<IntOperationFilterInput>;
  staffComplianceId?: InputMaybe<StringOperationFilterInput>;
  staffType?: InputMaybe<StringOperationFilterInput>;
  staffTypeId?: InputMaybe<IntOperationFilterInput>;
  totalOpportunities?: InputMaybe<IntOperationFilterInput>;
  totalWashes?: InputMaybe<IntOperationFilterInput>;
};

export type HhStaffComplianceSortInput = {
  currentShift?: InputMaybe<SortEnumType>;
  departmentId?: InputMaybe<SortEnumType>;
  previousShift?: InputMaybe<SortEnumType>;
  staffComplianceId?: InputMaybe<SortEnumType>;
  staffType?: InputMaybe<SortEnumType>;
  staffTypeId?: InputMaybe<SortEnumType>;
  totalOpportunities?: InputMaybe<SortEnumType>;
  totalWashes?: InputMaybe<SortEnumType>;
};

export type HhStaffComplianceStat = {
  __typename?: 'HHStaffComplianceStat';
  staffCompliancePercentage?: Maybe<Scalars['Int']['output']>;
};

export type HhStaffDto = {
  __typename?: 'HHStaffDto';
  caDepartmentIds: Array<Scalars['Int']['output']>;
  createdUtc: Scalars['String']['output'];
  customerId: Scalars['Int']['output'];
  department: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  parentRole: Scalars['String']['output'];
  role: Scalars['String']['output'];
  roleId: Scalars['Int']['output'];
  securedStaffName: Scalars['String']['output'];
  tagId: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type HandHygieneActivityConnection = {
  __typename?: 'HandHygieneActivityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<HandHygieneActivityEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<HhActivity>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type HandHygieneActivityEdge = {
  __typename?: 'HandHygieneActivityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HhActivity;
};

/** A connection to a list of items. */
export type HandHygieneStaffComplianceConnection = {
  __typename?: 'HandHygieneStaffComplianceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<HandHygieneStaffComplianceEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<HhStaffCompliance>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type HandHygieneStaffComplianceEdge = {
  __typename?: 'HandHygieneStaffComplianceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: HhStaffCompliance;
};

export type HierarchyBuildingDtoInput = {
  buildingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  siteIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type HierarchyFloorDtoInput = {
  buildingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  floorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  siteIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  subbuildingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type HierarchySiteDtoInput = {
  siteIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type HierarchySubBuildingDtoInput = {
  buildingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  siteIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  subbuildingIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IncomingTransmissionHistoryDto = {
  __typename?: 'IncomingTransmissionHistoryDto';
  createdUtc: Scalars['DateTime']['output'];
  customerId: Scalars['String']['output'];
  deliveryMode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  integrationConfigHttpMethod?: Maybe<Scalars['String']['output']>;
  integrationConfigId?: Maybe<Scalars['String']['output']>;
  integrationConfigName?: Maybe<Scalars['String']['output']>;
  integrationConfigUrl?: Maybe<Scalars['String']['output']>;
  internalEventId?: Maybe<Scalars['String']['output']>;
  internalEventName?: Maybe<Scalars['String']['output']>;
  jobRunId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
};

export type IntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type IntegrationConfigDto = {
  __typename?: 'IntegrationConfigDto';
  authConfigId?: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['String']['output'];
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  customerId: Scalars['String']['output'];
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  endpointUrl: Scalars['String']['output'];
  httpMethod?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  internalEventId?: Maybe<Scalars['String']['output']>;
  intervalMinutes?: Maybe<Scalars['Int']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  requestHeaders: Scalars['String']['output'];
  schedule: Array<Scalars['String']['output']>;
  sftpFilePath?: Maybe<Scalars['String']['output']>;
  sourceType: Scalars['String']['output'];
  templateId?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type IntegrationConfigListDto = {
  __typename?: 'IntegrationConfigListDto';
  integrationConfigs: Array<IntegrationConfigDto>;
  totalCount: Scalars['Int']['output'];
};

export type IntegrationConfigSourceTypeOptionDto = {
  __typename?: 'IntegrationConfigSourceTypeOptionDto';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type InternalEventDto = {
  __typename?: 'InternalEventDto';
  availableFields?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdUtc: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endpointUrl?: Maybe<Scalars['String']['output']>;
  graphqlQuery?: Maybe<Scalars['String']['output']>;
  httpMethod?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  protoMethodName?: Maybe<Scalars['String']['output']>;
  protoText?: Maybe<Scalars['String']['output']>;
  protocol?: Maybe<Scalars['String']['output']>;
  registrationServiceTls?: Maybe<Scalars['Boolean']['output']>;
  registrationServiceUrl?: Maybe<Scalars['String']['output']>;
  rmqRegistrationEventTypeId?: Maybe<Scalars['String']['output']>;
  subscriptionLastError?: Maybe<Scalars['String']['output']>;
  subscriptionSyncedUtc?: Maybe<Scalars['DateTime']['output']>;
  transport?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc: Scalars['DateTime']['output'];
};

export type IrtIncomingDebugDataSourceDto = {
  __typename?: 'IrtIncomingDebugDataSourceDto';
  key: Scalars['String']['output'];
  pins: Scalars['String']['output'];
};

export type IrtIncomingDebugErrorDto = {
  __typename?: 'IrtIncomingDebugErrorDto';
  at: Scalars['String']['output'];
  code: Scalars['String']['output'];
  detail: Scalars['String']['output'];
  message: Scalars['String']['output'];
  response: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  trail: Array<IrtIncomingDebugTrailEntryDto>;
};

export type IrtIncomingDebugIteratingDto = {
  __typename?: 'IrtIncomingDebugIteratingDto';
  index: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  nodeId: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type IrtIncomingDebugNextEntryDto = {
  __typename?: 'IrtIncomingDebugNextEntryDto';
  key: Scalars['String']['output'];
  nodeId: Scalars['String']['output'];
  port: Scalars['String']['output'];
};

export type IrtIncomingDebugRanBlockDto = {
  __typename?: 'IrtIncomingDebugRanBlockDto';
  blockId: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  nodeId: Scalars['String']['output'];
};

export type IrtIncomingDebugRenderedFieldDto = {
  __typename?: 'IrtIncomingDebugRenderedFieldDto';
  field: Scalars['String']['output'];
  more: Scalars['Int']['output'];
  template: Scalars['String']['output'];
  truncated: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type IrtIncomingDebugStartResultDto = {
  __typename?: 'IrtIncomingDebugStartResultDto';
  next: Array<IrtIncomingDebugNextEntryDto>;
};

export type IrtIncomingDebugTrailEntryDto = {
  __typename?: 'IrtIncomingDebugTrailEntryDto';
  blockId: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  nodeId: Scalars['String']['output'];
  via: Scalars['String']['output'];
};

export type IrtIncomingDebugVarInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type IrtIncomingDebugVisitDto = {
  __typename?: 'IrtIncomingDebugVisitDto';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type IrtIncomingDebugWarningDto = {
  __typename?: 'IrtIncomingDebugWarningDto';
  at: Scalars['String']['output'];
  code: Scalars['String']['output'];
  key: Scalars['String']['output'];
  message: Scalars['String']['output'];
  nodeId: Scalars['String']['output'];
};

export type IrtIncomingInternalEventDto = {
  __typename?: 'IrtIncomingInternalEventDto';
  availableFields?: Maybe<Scalars['String']['output']>;
  batchSize?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  grpcService?: Maybe<Scalars['String']['output']>;
  grpcTls?: Maybe<Scalars['Boolean']['output']>;
  headers?: Maybe<Scalars['String']['output']>;
  httpMethod?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  internalUrl?: Maybe<Scalars['String']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  protoMethodName?: Maybe<Scalars['String']['output']>;
  protoText?: Maybe<Scalars['String']['output']>;
  rmqRegistrationEventTypeId?: Maybe<Scalars['String']['output']>;
  transport: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type IrtIncomingPublishDestinationDto = {
  __typename?: 'IrtIncomingPublishDestinationDto';
  eventTypeId: Scalars['String']['output'];
  exchange: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type IrtIncomingStepDeltaDto = {
  __typename?: 'IrtIncomingStepDeltaDto';
  arrivedPort: Scalars['String']['output'];
  canRepeat: Scalars['Boolean']['output'];
  dataSources: Array<IrtIncomingDebugDataSourceDto>;
  error?: Maybe<IrtIncomingDebugErrorDto>;
  from: Scalars['String']['output'];
  iterating?: Maybe<IrtIncomingDebugIteratingDto>;
  next: Array<IrtIncomingDebugNextEntryDto>;
  pins: Scalars['String']['output'];
  ran?: Maybe<IrtIncomingDebugRanBlockDto>;
  rendered: Array<IrtIncomingDebugRenderedFieldDto>;
  status: Scalars['String']['output'];
  steps: Scalars['Int']['output'];
  takenOutputs: Array<Scalars['String']['output']>;
  via: Scalars['String']['output'];
  visits: Array<IrtIncomingDebugVisitDto>;
  warningTotal: Scalars['Int']['output'];
  warnings: Array<IrtIncomingDebugWarningDto>;
};

export type IrtIncomingWorkflowDto = {
  __typename?: 'IrtIncomingWorkflowDto';
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  customerId: Scalars['String']['output'];
  direction?: Maybe<Scalars['String']['output']>;
  graph: Scalars['String']['output'];
  id: Scalars['String']['output'];
  intervalMinutes?: Maybe<Scalars['Int']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pinsSchema?: Maybe<Scalars['String']['output']>;
  schedule: Array<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type IrtIncomingWorkflowRunDto = {
  __typename?: 'IrtIncomingWorkflowRunDto';
  errorMessage?: Maybe<Scalars['String']['output']>;
  eventPayload?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  internalEventId?: Maybe<Scalars['String']['output']>;
  internalEventName?: Maybe<Scalars['String']['output']>;
  isTest: Scalars['Boolean']['output'];
  retryOf?: Maybe<Scalars['String']['output']>;
  runAt: Scalars['String']['output'];
  status: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
  workflowName?: Maybe<Scalars['String']['output']>;
};

export type IrtIncomingWorkflowRunResultDto = {
  __typename?: 'IrtIncomingWorkflowRunResultDto';
  runId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type IrtOutgoingDebugDataSourceDto = {
  __typename?: 'IrtOutgoingDebugDataSourceDto';
  key: Scalars['String']['output'];
  pins: Scalars['String']['output'];
};

export type IrtOutgoingDebugErrorDto = {
  __typename?: 'IrtOutgoingDebugErrorDto';
  at: Scalars['String']['output'];
  code: Scalars['String']['output'];
  detail: Scalars['String']['output'];
  message: Scalars['String']['output'];
  response: Scalars['String']['output'];
  status: Scalars['Int']['output'];
  trail: Array<IrtOutgoingDebugTrailEntryDto>;
};

export type IrtOutgoingDebugIteratingDto = {
  __typename?: 'IrtOutgoingDebugIteratingDto';
  index: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  nodeId: Scalars['String']['output'];
  total: Scalars['Int']['output'];
};

export type IrtOutgoingDebugNextEntryDto = {
  __typename?: 'IrtOutgoingDebugNextEntryDto';
  key: Scalars['String']['output'];
  nodeId: Scalars['String']['output'];
  port: Scalars['String']['output'];
};

export type IrtOutgoingDebugRanBlockDto = {
  __typename?: 'IrtOutgoingDebugRanBlockDto';
  blockId: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  nodeId: Scalars['String']['output'];
};

export type IrtOutgoingDebugRenderedFieldDto = {
  __typename?: 'IrtOutgoingDebugRenderedFieldDto';
  field: Scalars['String']['output'];
  more: Scalars['Int']['output'];
  template: Scalars['String']['output'];
  truncated: Scalars['Boolean']['output'];
  value: Scalars['String']['output'];
};

export type IrtOutgoingDebugStartResultDto = {
  __typename?: 'IrtOutgoingDebugStartResultDto';
  next: Array<IrtOutgoingDebugNextEntryDto>;
};

export type IrtOutgoingDebugTrailEntryDto = {
  __typename?: 'IrtOutgoingDebugTrailEntryDto';
  blockId: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  nodeId: Scalars['String']['output'];
  via: Scalars['String']['output'];
};

export type IrtOutgoingDebugVarInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type IrtOutgoingDebugVisitDto = {
  __typename?: 'IrtOutgoingDebugVisitDto';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type IrtOutgoingDebugWarningDto = {
  __typename?: 'IrtOutgoingDebugWarningDto';
  at: Scalars['String']['output'];
  code: Scalars['String']['output'];
  key: Scalars['String']['output'];
  message: Scalars['String']['output'];
  nodeId: Scalars['String']['output'];
};

export type IrtOutgoingStepDeltaDto = {
  __typename?: 'IrtOutgoingStepDeltaDto';
  arrivedPort: Scalars['String']['output'];
  canRepeat: Scalars['Boolean']['output'];
  dataSources: Array<IrtOutgoingDebugDataSourceDto>;
  error?: Maybe<IrtOutgoingDebugErrorDto>;
  from: Scalars['String']['output'];
  iterating?: Maybe<IrtOutgoingDebugIteratingDto>;
  next: Array<IrtOutgoingDebugNextEntryDto>;
  pins: Scalars['String']['output'];
  ran?: Maybe<IrtOutgoingDebugRanBlockDto>;
  rendered: Array<IrtOutgoingDebugRenderedFieldDto>;
  status: Scalars['String']['output'];
  steps: Scalars['Int']['output'];
  takenOutputs: Array<Scalars['String']['output']>;
  via: Scalars['String']['output'];
  visits: Array<IrtOutgoingDebugVisitDto>;
  warningTotal: Scalars['Int']['output'];
  warnings: Array<IrtOutgoingDebugWarningDto>;
};

export type IrtOutgoingWorkflowDto = {
  __typename?: 'IrtOutgoingWorkflowDto';
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  customerId: Scalars['String']['output'];
  direction?: Maybe<Scalars['String']['output']>;
  graph: Scalars['String']['output'];
  id: Scalars['String']['output'];
  intervalMinutes?: Maybe<Scalars['Int']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pinsSchema?: Maybe<Scalars['String']['output']>;
  schedule: Array<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type IrtOutgoingWorkflowRunDto = {
  __typename?: 'IrtOutgoingWorkflowRunDto';
  errorMessage?: Maybe<Scalars['String']['output']>;
  eventPayload?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  internalEventId?: Maybe<Scalars['String']['output']>;
  internalEventName?: Maybe<Scalars['String']['output']>;
  isTest: Scalars['Boolean']['output'];
  retryOf?: Maybe<Scalars['String']['output']>;
  runAt: Scalars['String']['output'];
  status: Scalars['String']['output'];
  trigger: Scalars['String']['output'];
  workflowId: Scalars['String']['output'];
  workflowName?: Maybe<Scalars['String']['output']>;
};

export type IrtOutgoingWorkflowRunResultDto = {
  __typename?: 'IrtOutgoingWorkflowRunResultDto';
  runId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type IrtOutgoingWorkflowRunRetryResultDto = {
  __typename?: 'IrtOutgoingWorkflowRunRetryResultDto';
  runId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type JobRunListDto = {
  __typename?: 'JobRunListDto';
  jobRuns: Array<JobRunListItemDto>;
  totalCount: Scalars['Int']['output'];
};

export type JobRunListItemDto = {
  __typename?: 'JobRunListItemDto';
  configId: Scalars['String']['output'];
  configName: Scalars['String']['output'];
  durationSeconds?: Maybe<Scalars['Float']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['String']['output']>;
  lastJobRunAt: Scalars['String']['output'];
  pullRetryCount: Scalars['Int']['output'];
  runId: Scalars['String']['output'];
  stats?: Maybe<JobRunStatsDto>;
  status?: Maybe<Scalars['String']['output']>;
};

export type JobRunStatsDto = {
  __typename?: 'JobRunStatsDto';
  created?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Int']['output']>;
  failed?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type KeyValuePairOfStringAndString = {
  __typename?: 'KeyValuePairOfStringAndString';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type KeyValuePairOfStringAndStringFilterInput = {
  and?: InputMaybe<Array<KeyValuePairOfStringAndStringFilterInput>>;
  key?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<KeyValuePairOfStringAndStringFilterInput>>;
  value?: InputMaybe<StringOperationFilterInput>;
};

export type LicenseInfo = {
  __typename?: 'LicenseInfo';
  is_assets_rt_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_duress_rt_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_hand_hygiene_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_workflow_rt_enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type ListFilterInputTypeOfAssetGroupFilterInput = {
  all?: InputMaybe<AssetGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AssetGroupFilterInput>;
  some?: InputMaybe<AssetGroupFilterInput>;
};

export type ListFilterInputTypeOfAssetGroupInfoFilterInput = {
  all?: InputMaybe<AssetGroupInfoFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AssetGroupInfoFilterInput>;
  some?: InputMaybe<AssetGroupInfoFilterInput>;
};

export type ListFilterInputTypeOfAssetsFilterInput = {
  all?: InputMaybe<AssetsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<AssetsFilterInput>;
  some?: InputMaybe<AssetsFilterInput>;
};

export type ListFilterInputTypeOfCaLocationDataFilterInput = {
  all?: InputMaybe<CaLocationDataFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CaLocationDataFilterInput>;
  some?: InputMaybe<CaLocationDataFilterInput>;
};

export type ListFilterInputTypeOfCoordinateFilterInput = {
  all?: InputMaybe<CoordinateFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<CoordinateFilterInput>;
  some?: InputMaybe<CoordinateFilterInput>;
};

export type ListFilterInputTypeOfLocationGroupFilterInput = {
  all?: InputMaybe<LocationGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<LocationGroupFilterInput>;
  some?: InputMaybe<LocationGroupFilterInput>;
};

export type ListFilterInputTypeOfParLevelsFilterInput = {
  all?: InputMaybe<ParLevelsFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<ParLevelsFilterInput>;
  some?: InputMaybe<ParLevelsFilterInput>;
};

export type ListFilterInputTypeOfStaffGroupFilterInput = {
  all?: InputMaybe<StaffGroupFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StaffGroupFilterInput>;
  some?: InputMaybe<StaffGroupFilterInput>;
};

export type ListFilterInputTypeOfStaffMemberFilterInput = {
  all?: InputMaybe<StaffMemberFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StaffMemberFilterInput>;
  some?: InputMaybe<StaffMemberFilterInput>;
};

export type ListIntOperationFilterInput = {
  all?: InputMaybe<IntOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<IntOperationFilterInput>;
  some?: InputMaybe<IntOperationFilterInput>;
};

export type ListStringOperationFilterInput = {
  all?: InputMaybe<StringOperationFilterInput>;
  any?: InputMaybe<Scalars['Boolean']['input']>;
  none?: InputMaybe<StringOperationFilterInput>;
  some?: InputMaybe<StringOperationFilterInput>;
};

export type LiveTagAssigneeInfo = {
  __typename?: 'LiveTagAssigneeInfo';
  assignee: Scalars['String']['output'];
  assigneedName: Scalars['String']['output'];
  patient?: Maybe<AssignedPatient>;
  staff?: Maybe<AssignedStaff>;
  tag_value: Scalars['String']['output'];
};

export type LocationGroup = {
  __typename?: 'LocationGroup';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type LocationGroupFilterInput = {
  and?: InputMaybe<Array<LocationGroupFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LocationGroupFilterInput>>;
};

export type LocationGroups = {
  __typename?: 'LocationGroups';
  id: Scalars['Int']['output'];
  locations: Array<CaLocationData>;
  name: Scalars['String']['output'];
  siteId: Scalars['Int']['output'];
  siteName: Scalars['String']['output'];
};

export type LocationGroupsFilterInput = {
  and?: InputMaybe<Array<LocationGroupsFilterInput>>;
  id?: InputMaybe<IntOperationFilterInput>;
  locations?: InputMaybe<ListFilterInputTypeOfCaLocationDataFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LocationGroupsFilterInput>>;
  siteId?: InputMaybe<IntOperationFilterInput>;
  siteName?: InputMaybe<StringOperationFilterInput>;
};

export type LocationGroupsSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  siteId?: InputMaybe<SortEnumType>;
  siteName?: InputMaybe<SortEnumType>;
};

export type LocationStatus = {
  __typename?: 'LocationStatus';
  created_by?: Maybe<Scalars['String']['output']>;
  created_utc: Scalars['DateTime']['output'];
  customer_id: Scalars['Int']['output'];
  deleted_by?: Maybe<Scalars['String']['output']>;
  deleted_utc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  location_status_color: Scalars['String']['output'];
  name: Scalars['String']['output'];
  toJson: Scalars['String']['output'];
  updated_by?: Maybe<Scalars['String']['output']>;
  updated_utc?: Maybe<Scalars['DateTime']['output']>;
};

export type Locations = {
  __typename?: 'Locations';
  buildingName?: Maybe<Scalars['String']['output']>;
  departmentIds?: Maybe<Array<Scalars['Int']['output']>>;
  departmentNames?: Maybe<Array<Scalars['String']['output']>>;
  entryTime?: Maybe<Scalars['DateTime']['output']>;
  exitTime?: Maybe<Scalars['DateTime']['output']>;
  floorName?: Maybe<Scalars['String']['output']>;
  fromLocationValue?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  siteName?: Maybe<Scalars['String']['output']>;
  tagNumber?: Maybe<Scalars['String']['output']>;
  toLocationValue?: Maybe<Scalars['String']['output']>;
};

export type LocationsArgsDtoInput = {
  caLocationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type LocationsDtoInput = {
  department_ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  floorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  locationTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
};

export type LocationsFilterInput = {
  and?: InputMaybe<Array<LocationsFilterInput>>;
  buildingName?: InputMaybe<StringOperationFilterInput>;
  departmentIds?: InputMaybe<ListIntOperationFilterInput>;
  departmentNames?: InputMaybe<ListStringOperationFilterInput>;
  entryTime?: InputMaybe<DateTimeOperationFilterInput>;
  exitTime?: InputMaybe<DateTimeOperationFilterInput>;
  floorName?: InputMaybe<StringOperationFilterInput>;
  fromLocationValue?: InputMaybe<StringOperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<LocationsFilterInput>>;
  siteName?: InputMaybe<StringOperationFilterInput>;
  tagNumber?: InputMaybe<StringOperationFilterInput>;
  toLocationValue?: InputMaybe<StringOperationFilterInput>;
};

export type LocationsSortInput = {
  buildingName?: InputMaybe<SortEnumType>;
  entryTime?: InputMaybe<SortEnumType>;
  exitTime?: InputMaybe<SortEnumType>;
  floorName?: InputMaybe<SortEnumType>;
  fromLocationValue?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<SortEnumType>;
  siteName?: InputMaybe<SortEnumType>;
  tagNumber?: InputMaybe<SortEnumType>;
  toLocationValue?: InputMaybe<SortEnumType>;
};

export enum LocationsType {
  CentrakCoreDeviceId = 'CENTRAK_CORE_DEVICE_ID',
  ConnectRtlocationId = 'CONNECT_RTLOCATION_ID',
  NoLocationType = 'NO_LOCATION_TYPE'
}

export type LocationsTypeOperationFilterInput = {
  eq?: InputMaybe<LocationsType>;
  in?: InputMaybe<Array<LocationsType>>;
  neq?: InputMaybe<LocationsType>;
  nin?: InputMaybe<Array<LocationsType>>;
};

export type ManualEscalationDtoInput = {
  alertId: Scalars['String']['input'];
  escalationId: Scalars['String']['input'];
  escalationLevel: Scalars['Int']['input'];
};

export type ManualGroupDtoInput = {
  alertId: Scalars['String']['input'];
  messageGroupIds: Array<Scalars['String']['input']>;
};

export type ManualResponse = {
  __typename?: 'ManualResponse';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<ManualResponse>;
  message?: Maybe<Scalars['String']['output']>;
  result: Scalars['Boolean']['output'];
};

export type MappingTemplateDto = {
  __typename?: 'MappingTemplateDto';
  internalEventId: Scalars['String']['output'];
  mapping: Scalars['String']['output'];
  name: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  usageCount: Scalars['Int']['output'];
};

export type MappingTemplateListDto = {
  __typename?: 'MappingTemplateListDto';
  mappingTemplates: Array<MappingTemplateDto>;
  totalCount: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addDuressAckMessage: Array<DefaultRespondMessage>;
  addDuressEscalation: ReplyStatus;
  addDuressOutboundMessage: ReplyStatus;
  addDuressRule: ReplyStatus;
  addHandHygieneDepartment: HhDepartment;
  addHandHygieneDevice: HhDevice;
  addHandHygieneLocation: HhLocation;
  addHandHygieneMessageGroup: HhMessageGroup;
  addStatusUpdateMessage: Array<StatusUpdateRespondMessage>;
  addUpdateIoTDevice: Array<DeviceModel>;
  artAddAsset: Array<Assets>;
  artAddAssetGroup: Array<AssetGroups>;
  artAddAssetType: Array<AssetTypes>;
  artAddParLevel: Array<ParLevelList>;
  artAddRule: Array<Rule>;
  artAddSavedSearches: Array<SavedSearches>;
  artAddScheduledNotification: Array<ScheduledNotification>;
  artAddStaffGroup: Array<StaffGroups>;
  artReindexAllAssets: Response;
  artRemoveAsset: Array<AssetRemoveModel>;
  artRemoveAssetGroup: Array<AssetRemoveModel>;
  artRemoveAssetType: Array<AssetRemoveModel>;
  artRemoveParLevel: Array<AssetRemoveModel>;
  artRemoveRule: Array<AssetRemoveModel>;
  artRemoveSavedSearches: Array<AssetRemoveModel>;
  artRemoveScheduledNotification: Array<RemoveScheduledNotification>;
  artRemoveStaffGroup: Array<AssetRemoveModel>;
  artSyncAssetTags: Response;
  artUpdateAsset: Array<Assets>;
  artUpdateAssetGroup: Array<AssetGroups>;
  artUpdateAssetType: Array<AssetTypes>;
  artUpdateParLevel: Array<ParLevelList>;
  artUpdateRule: Array<Rule>;
  artUpdateScheduledNotification: Array<ScheduledNotification>;
  artUpdateStaffGroup: Array<StaffGroups>;
  bulkCreateAlertEmItems: Array<AlertConditionEmItemDto>;
  bulkCreateAlertRecipients: Array<AlertRecipientDto>;
  bulkDeleteAlertRecipients: Scalars['Boolean']['output'];
  bulkRemoveAlertEmItems: Scalars['Boolean']['output'];
  bulkUpdateAlertRecipients: Array<AlertRecipientDto>;
  createAlertEmItem: AlertConditionEmItemDto;
  createAlertRecipient: AlertRecipientDto;
  createAlertResponse: AlertResponseDto;
  createAuthConfig: AuthConfigDto;
  createEMItem: EmItemDto;
  createEMItemGroup: EmItemGroupDto;
  createEMItemType: EmItemTypeDto;
  createEMRecipientGroup: RecipientGroupDto;
  createEMTag: EmTagDto;
  createEmAlert: AlertDto;
  createEmAlertCondition: AlertConditionDto;
  createHandHygieneRule: HhRule;
  createIntegrateTemplate: TemplateDto;
  createIntegrationConfig: IntegrationConfigDto;
  createIrtIncomingWorkflow: IrtIncomingWorkflowDto;
  createIrtOutgoingWorkflow: IrtOutgoingWorkflowDto;
  createMappingTemplate: MappingTemplateDto;
  createOutboundConfig: OutboundConfigDto;
  createProbe: ProbeDto;
  createProbeType: ProbeTypeDto;
  deleteAlertRecipient: Scalars['Boolean']['output'];
  deleteAlertResponse: Scalars['Boolean']['output'];
  deleteDuressAckMessage: DeleteRespondReply;
  deleteDuressEscalation: ReplyStatus;
  deleteDuressOutboundMessage: ReplyStatus;
  deleteDuressRule: ReplyStatus;
  deleteEMItem: Scalars['Boolean']['output'];
  deleteEMItemGroup: Scalars['Boolean']['output'];
  deleteEMItemType: Scalars['Boolean']['output'];
  deleteEMRecipientGroup: Scalars['Boolean']['output'];
  deleteEMTag: Scalars['Boolean']['output'];
  deleteEmAlertCondition: Scalars['Boolean']['output'];
  deleteProbe: Scalars['Boolean']['output'];
  deleteProbeType: Scalars['Boolean']['output'];
  deleteStatusUpdateMessage: DeleteStatusUpdateReply;
  duressManualEscalationNotify: ManualResponse;
  duressManualgroupNotify: ManualResponse;
  publishEmRtlsMessage: Scalars['String']['output'];
  publishIoTEvent: Status;
  registerIoTDevice: Array<RegisterIoTDeviceResponseDto>;
  registerWpnClient: WnsSubscriptionResponse;
  removeAlertEmItem: Scalars['Boolean']['output'];
  removeAuthConfig: Scalars['Boolean']['output'];
  removeHandHygieneDepartment: RemoveModel;
  removeHandHygieneMessage: RemoveModel;
  removeHandHygieneMessageGroupFromRules: RemoveModel;
  removeHandHygieneRule: RemoveModel;
  removeIntegrateTemplate: Scalars['Boolean']['output'];
  removeIntegrationConfig: Scalars['Boolean']['output'];
  removeIrtIncomingWorkflow: Scalars['Boolean']['output'];
  removeIrtOutgoingWorkflow: Scalars['Boolean']['output'];
  removeMappingTemplate: Scalars['Boolean']['output'];
  removeOutboundConfig: Scalars['Boolean']['output'];
  repeatIrtIncomingWorkflowDebug: IrtIncomingStepDeltaDto;
  repeatIrtOutgoingWorkflowDebug: IrtOutgoingStepDeltaDto;
  retryIrtOutgoingWorkflowRun: IrtOutgoingWorkflowRunRetryResultDto;
  runIrtIncomingWorkflow: IrtIncomingWorkflowRunResultDto;
  runIrtOutgoingWorkflow: IrtOutgoingWorkflowRunResultDto;
  startIrtIncomingWorkflowDebug: IrtIncomingDebugStartResultDto;
  startIrtOutgoingWorkflowDebug: IrtOutgoingDebugStartResultDto;
  stepIrtIncomingWorkflowDebug: IrtIncomingStepDeltaDto;
  stepIrtOutgoingWorkflowDebug: IrtOutgoingStepDeltaDto;
  stopIrtIncomingWorkflowDebug: Scalars['Boolean']['output'];
  stopIrtOutgoingWorkflowDebug: Scalars['Boolean']['output'];
  triggerIntegrationConfig: TriggerIntegrationConfigDto;
  updateAlertConditionEmItems: UpdateAlertConditionEmItemsResponse;
  updateAlertRecipient: AlertRecipientDto;
  updateAlertResponse: AlertResponseDto;
  updateAuthConfig: AuthConfigDto;
  updateDuressAcceptAlert: UpdateReplyStatus;
  updateDuressAckMessage: Array<DefaultRespondMessage>;
  updateDuressCloseAlert: UpdateReplyStatus;
  updateDuressStatusUpdateAlert: UpdateReplyStatus;
  updateEMItem: EmItemDto;
  updateEMItemGroup: EmItemGroupDto;
  updateEMItemType: EmItemTypeDto;
  updateEMRecipientGroup: RecipientGroupDto;
  updateEMTag: EmTagDto;
  updateEmAlert: AlertDto;
  updateEmAlertCondition: AlertConditionDto;
  updateHandHygieneDepartment: HhDepartment;
  updateHandHygieneDevice: HhDevice;
  updateHandHygieneLocation: HhLocation;
  updateHandHygieneMessageGroup: HhMessageGroup;
  updateHandHygieneRule: HhRule;
  updateIntegrateTemplate: TemplateDto;
  updateIntegrationConfig: IntegrationConfigDto;
  updateIrtIncomingWorkflow: IrtIncomingWorkflowDto;
  updateIrtOutgoingWorkflow: IrtOutgoingWorkflowDto;
  updateMappingTemplate: MappingTemplateDto;
  updateOutboundConfig: OutboundConfigDto;
  updateProbe: ProbeDto;
  updateProbeType: ProbeTypeDto;
  updateUserPreferences: Scalars['Boolean']['output'];
};


export type MutationAddDuressAckMessageArgs = {
  input: AckRespondMsgDtoInput;
};


export type MutationAddDuressEscalationArgs = {
  input: AddEscalationDtoInput;
};


export type MutationAddDuressOutboundMessageArgs = {
  input: AddOutboundMsgDtoInput;
};


export type MutationAddDuressRuleArgs = {
  input: AddRuleDtoInput;
};


export type MutationAddHandHygieneDepartmentArgs = {
  input: AddDepartmentDtoInput;
};


export type MutationAddHandHygieneDeviceArgs = {
  input: AddDeviceOptionsDtoInput;
};


export type MutationAddHandHygieneLocationArgs = {
  input: AddLocationDtoInput;
};


export type MutationAddHandHygieneMessageGroupArgs = {
  input: AddMessageGroupDtoInput;
};


export type MutationAddStatusUpdateMessageArgs = {
  input: StatusUpdateMsgDtoInput;
};


export type MutationAddUpdateIoTDeviceArgs = {
  input: RequestAddUpdateIoTDeviceDtoInput;
};


export type MutationArtAddAssetArgs = {
  input: Array<AddAssetDtoInput>;
};


export type MutationArtAddAssetGroupArgs = {
  input: Array<AddAssetGroupDtoInput>;
};


export type MutationArtAddAssetTypeArgs = {
  input: Array<AddAssetTypeDtoInput>;
};


export type MutationArtAddParLevelArgs = {
  input: Array<AddParLevelDtoInput>;
};


export type MutationArtAddRuleArgs = {
  input: Array<AddArtRuleDtoInput>;
};


export type MutationArtAddSavedSearchesArgs = {
  input: Array<AddSavedSearchesInput>;
};


export type MutationArtAddScheduledNotificationArgs = {
  input: Array<AddScheduledNotificationInput>;
};


export type MutationArtAddStaffGroupArgs = {
  input: Array<AddStaffGroupDtoInput>;
};


export type MutationArtRemoveAssetArgs = {
  input: Array<RemoveAssetDtoInput>;
};


export type MutationArtRemoveAssetGroupArgs = {
  input: Array<RemoveAssetGroupDtoInput>;
};


export type MutationArtRemoveAssetTypeArgs = {
  input: Array<RemoveAssetTypeDtoInput>;
};


export type MutationArtRemoveParLevelArgs = {
  input: Array<RemoveParLevelDtoInput>;
};


export type MutationArtRemoveRuleArgs = {
  input: Array<RemoveArtRuleDtoInput>;
};


export type MutationArtRemoveSavedSearchesArgs = {
  input: Array<RemoveSavedSearchesInput>;
};


export type MutationArtRemoveScheduledNotificationArgs = {
  input: Array<Scalars['String']['input']>;
};


export type MutationArtRemoveStaffGroupArgs = {
  input: Array<RemoveStaffGroupDtoInput>;
};


export type MutationArtSyncAssetTagsArgs = {
  input: Array<SyncAssetTagDtoInput>;
};


export type MutationArtUpdateAssetArgs = {
  input: Array<UpdateAssetDtoInput>;
};


export type MutationArtUpdateAssetGroupArgs = {
  input: Array<UpdateAssetGroupDtoInput>;
};


export type MutationArtUpdateAssetTypeArgs = {
  input: Array<UpdateAssetTypeDtoInput>;
};


export type MutationArtUpdateParLevelArgs = {
  input: Array<UpdateParLevelDtoInput>;
};


export type MutationArtUpdateRuleArgs = {
  input: Array<UpdateArtRuleDtoInput>;
};


export type MutationArtUpdateScheduledNotificationArgs = {
  input: Array<UpdateScheduledNotificationInput>;
};


export type MutationArtUpdateStaffGroupArgs = {
  input: Array<UpdateStaffGroupDtoInput>;
};


export type MutationBulkCreateAlertEmItemsArgs = {
  input: BulkCreateAlertConditionEmItemInput;
};


export type MutationBulkCreateAlertRecipientsArgs = {
  input: BulkCreateAlertRecipientInput;
};


export type MutationBulkDeleteAlertRecipientsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationBulkRemoveAlertEmItemsArgs = {
  alertConditionId: Scalars['String']['input'];
  emItemIds: Array<Scalars['String']['input']>;
};


export type MutationBulkUpdateAlertRecipientsArgs = {
  input: BulkUpdateAlertRecipientInput;
};


export type MutationCreateAlertEmItemArgs = {
  input: CreateAlertConditionEmItemInput;
};


export type MutationCreateAlertRecipientArgs = {
  input: CreateAlertRecipientInput;
};


export type MutationCreateAlertResponseArgs = {
  input: CreateAlertResponseInput;
};


export type MutationCreateAuthConfigArgs = {
  input: CreateAuthConfigInput;
};


export type MutationCreateEmItemArgs = {
  input: CreateEmItemInput;
};


export type MutationCreateEmItemGroupArgs = {
  input: CreateEmItemGroupInput;
};


export type MutationCreateEmItemTypeArgs = {
  input: CreateEmItemTypeInput;
};


export type MutationCreateEmRecipientGroupArgs = {
  input: CreateRecipientGroupInput;
};


export type MutationCreateEmTagArgs = {
  input: CreateEmTagInput;
};


export type MutationCreateEmAlertArgs = {
  input: CreateAlertInput;
};


export type MutationCreateEmAlertConditionArgs = {
  input: CreateAlertConditionInput;
};


export type MutationCreateHandHygieneRuleArgs = {
  input: CreateHhRuleDtoInput;
};


export type MutationCreateIntegrateTemplateArgs = {
  input: CreateTemplateInput;
};


export type MutationCreateIntegrationConfigArgs = {
  input: CreateIntegrationConfigInput;
};


export type MutationCreateIrtIncomingWorkflowArgs = {
  input: CreateIrtIncomingWorkflowInput;
};


export type MutationCreateIrtOutgoingWorkflowArgs = {
  input: CreateIrtOutgoingWorkflowInput;
};


export type MutationCreateMappingTemplateArgs = {
  input: CreateMappingTemplateInput;
};


export type MutationCreateOutboundConfigArgs = {
  input: CreateOutboundConfigInput;
};


export type MutationCreateProbeArgs = {
  input: CreateProbeInput;
};


export type MutationCreateProbeTypeArgs = {
  input: CreateProbeTypeInput;
};


export type MutationDeleteAlertRecipientArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteAlertResponseArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteDuressAckMessageArgs = {
  input: DeleteRespondMsgDtoInput;
};


export type MutationDeleteDuressEscalationArgs = {
  input: DeleteEscalationDtoInput;
};


export type MutationDeleteDuressOutboundMessageArgs = {
  input: DeleteOutboundMsgDtoInput;
};


export type MutationDeleteDuressRuleArgs = {
  input: DeleteRuleDtoInput;
};


export type MutationDeleteEmItemArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteEmItemGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteEmItemTypeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteEmRecipientGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteEmTagArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteEmAlertConditionArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteProbeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteProbeTypeArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteStatusUpdateMessageArgs = {
  input: DeleteStatusUpdateMsgDtoInput;
};


export type MutationDuressManualEscalationNotifyArgs = {
  input: ManualEscalationDtoInput;
};


export type MutationDuressManualgroupNotifyArgs = {
  input: ManualGroupDtoInput;
};


export type MutationPublishEmRtlsMessageArgs = {
  input: PublishEmRtlsMessageInput;
};


export type MutationPublishIoTEventArgs = {
  input: BleTagEventDtoInput;
};


export type MutationRegisterIoTDeviceArgs = {
  input: RegisterIoTDeviceRequestDtoInput;
};


export type MutationRegisterWpnClientArgs = {
  input: RegisterWpnClientDtoInput;
};


export type MutationRemoveAlertEmItemArgs = {
  alertConditionId: Scalars['String']['input'];
  emItemId: Scalars['String']['input'];
};


export type MutationRemoveAuthConfigArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveHandHygieneDepartmentArgs = {
  input: RemoveDepartmentDtoInput;
};


export type MutationRemoveHandHygieneMessageArgs = {
  input: RemoveMessageGroupDtoInput;
};


export type MutationRemoveHandHygieneMessageGroupFromRulesArgs = {
  input: RemoveRuleDtoInput;
};


export type MutationRemoveHandHygieneRuleArgs = {
  input: RemoveRuleDtoInput;
};


export type MutationRemoveIntegrateTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveIntegrationConfigArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveIrtIncomingWorkflowArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveIrtOutgoingWorkflowArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveMappingTemplateArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveOutboundConfigArgs = {
  id: Scalars['String']['input'];
};


export type MutationRepeatIrtIncomingWorkflowDebugArgs = {
  id: Scalars['String']['input'];
};


export type MutationRepeatIrtOutgoingWorkflowDebugArgs = {
  id: Scalars['String']['input'];
};


export type MutationRetryIrtOutgoingWorkflowRunArgs = {
  id: Scalars['String']['input'];
};


export type MutationRunIrtIncomingWorkflowArgs = {
  encoding?: TemplateBodyEncoding;
  eventPayload?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  mode: Scalars['String']['input'];
};


export type MutationRunIrtOutgoingWorkflowArgs = {
  encoding?: TemplateBodyEncoding;
  eventPayload?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  mode: Scalars['String']['input'];
};


export type MutationStartIrtIncomingWorkflowDebugArgs = {
  encoding?: TemplateBodyEncoding;
  graph: Scalars['String']['input'];
  graphEncoding?: TemplateBodyEncoding;
  id: Scalars['String']['input'];
  triggerPins?: InputMaybe<Scalars['String']['input']>;
  vars?: InputMaybe<Array<IrtIncomingDebugVarInput>>;
};


export type MutationStartIrtOutgoingWorkflowDebugArgs = {
  encoding?: TemplateBodyEncoding;
  graph: Scalars['String']['input'];
  graphEncoding?: TemplateBodyEncoding;
  id: Scalars['String']['input'];
  triggerPins?: InputMaybe<Scalars['String']['input']>;
  vars?: InputMaybe<Array<IrtOutgoingDebugVarInput>>;
};


export type MutationStepIrtIncomingWorkflowDebugArgs = {
  id: Scalars['String']['input'];
};


export type MutationStepIrtOutgoingWorkflowDebugArgs = {
  id: Scalars['String']['input'];
};


export type MutationStopIrtIncomingWorkflowDebugArgs = {
  id: Scalars['String']['input'];
};


export type MutationStopIrtOutgoingWorkflowDebugArgs = {
  id: Scalars['String']['input'];
};


export type MutationTriggerIntegrationConfigArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateAlertConditionEmItemsArgs = {
  alertConditionId: Scalars['String']['input'];
  emItemIds: Array<Scalars['String']['input']>;
};


export type MutationUpdateAlertRecipientArgs = {
  input: UpdateAlertRecipientInput;
};


export type MutationUpdateAlertResponseArgs = {
  input: UpdateAlertResponseInput;
};


export type MutationUpdateAuthConfigArgs = {
  input: UpdateAuthConfigInput;
};


export type MutationUpdateDuressAcceptAlertArgs = {
  input: AlertAcceptDtoInput;
};


export type MutationUpdateDuressAckMessageArgs = {
  input: UpdateRespondMsgDtoInput;
};


export type MutationUpdateDuressCloseAlertArgs = {
  input: AlertCloseDtoInput;
};


export type MutationUpdateDuressStatusUpdateAlertArgs = {
  input: AlertStatusUpdateDtoInput;
};


export type MutationUpdateEmItemArgs = {
  input: UpdateEmItemInput;
};


export type MutationUpdateEmItemGroupArgs = {
  input: UpdateEmItemGroupInput;
};


export type MutationUpdateEmItemTypeArgs = {
  input: UpdateEmItemTypeInput;
};


export type MutationUpdateEmRecipientGroupArgs = {
  input: UpdateRecipientGroupInput;
};


export type MutationUpdateEmTagArgs = {
  input: UpdateEmTagInput;
};


export type MutationUpdateEmAlertArgs = {
  input: UpdateAlertInput;
};


export type MutationUpdateEmAlertConditionArgs = {
  input: UpdateAlertConditionInput;
};


export type MutationUpdateHandHygieneDepartmentArgs = {
  input: UpdateDepartmentDtoInput;
};


export type MutationUpdateHandHygieneDeviceArgs = {
  input: UpdateDeviceDtoInput;
};


export type MutationUpdateHandHygieneLocationArgs = {
  input: UpdateLocationDtoInput;
};


export type MutationUpdateHandHygieneMessageGroupArgs = {
  input: UpdateMessageGroupDtoInput;
};


export type MutationUpdateHandHygieneRuleArgs = {
  input: UpdateHhRuleDtoInput;
};


export type MutationUpdateIntegrateTemplateArgs = {
  input: UpdateTemplateInput;
};


export type MutationUpdateIntegrationConfigArgs = {
  input: UpdateIntegrationConfigInput;
};


export type MutationUpdateIrtIncomingWorkflowArgs = {
  input: UpdateIrtIncomingWorkflowInput;
};


export type MutationUpdateIrtOutgoingWorkflowArgs = {
  input: UpdateIrtOutgoingWorkflowInput;
};


export type MutationUpdateMappingTemplateArgs = {
  input: UpdateMappingTemplateInput;
};


export type MutationUpdateOutboundConfigArgs = {
  input: UpdateOutboundConfigInput;
};


export type MutationUpdateProbeArgs = {
  input: UpdateProbeInput;
};


export type MutationUpdateProbeTypeArgs = {
  input: UpdateProbeTypeInput;
};


export type MutationUpdateUserPreferencesArgs = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['JSON']['input']>;
};

export type NistCertificateDto = {
  __typename?: 'NistCertificateDto';
  deviceType: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  pdfData?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type NullableOfAreaRestrictionDirectionOperationFilterInput = {
  eq?: InputMaybe<AreaRestrictionDirection>;
  in?: InputMaybe<Array<InputMaybe<AreaRestrictionDirection>>>;
  neq?: InputMaybe<AreaRestrictionDirection>;
  nin?: InputMaybe<Array<InputMaybe<AreaRestrictionDirection>>>;
};

export type NullableOfBatteryStatusOperationFilterInput = {
  eq?: InputMaybe<BatteryStatus>;
  in?: InputMaybe<Array<InputMaybe<BatteryStatus>>>;
  neq?: InputMaybe<BatteryStatus>;
  nin?: InputMaybe<Array<InputMaybe<BatteryStatus>>>;
};

export type OutboundConfigDto = {
  __typename?: 'OutboundConfigDto';
  authConfigId?: Maybe<Scalars['String']['output']>;
  batchSize?: Maybe<Scalars['Int']['output']>;
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  customerId: Scalars['String']['output'];
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  headers?: Maybe<Scalars['String']['output']>;
  httpMethod: Scalars['String']['output'];
  id: Scalars['String']['output'];
  internalEvent?: Maybe<InternalEventDto>;
  internalEventId: Scalars['String']['output'];
  intervalMinutes?: Maybe<Scalars['Int']['output']>;
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  schedule: Array<Scalars['String']['output']>;
  template?: Maybe<TemplateDto>;
  templateId: Scalars['String']['output'];
  transportType?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};

export type OutboundConfigRecipientsInput = {
  departmentId: Scalars['String']['input'];
  staffId: Scalars['String']['input'];
};

export type OutboundConfigTypeInput = {
  fromEmail: Scalars['String']['input'];
  fromSMS: Scalars['String']['input'];
  replyEmail: Scalars['String']['input'];
  smsType: Scalars['String']['input'];
  typeId: Scalars['Int']['input'];
  windowsNotifyByClient: Scalars['Boolean']['input'];
};

export type OutboundTypes = {
  __typename?: 'OutboundTypes';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<OutboundTypes>;
  fromEmail?: Maybe<Scalars['String']['output']>;
  fromSMS?: Maybe<Scalars['String']['output']>;
  replyEmail?: Maybe<Scalars['String']['output']>;
  smsType?: Maybe<Scalars['String']['output']>;
  typeId: Scalars['Int']['output'];
  windowsNotifyClient: Scalars['Boolean']['output'];
};

export type OutgoingTransmissionHistoryDto = {
  __typename?: 'OutgoingTransmissionHistoryDto';
  createdUtc: Scalars['DateTime']['output'];
  customerId: Scalars['String']['output'];
  deliveryMode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  internalEventId?: Maybe<Scalars['String']['output']>;
  internalEventName?: Maybe<Scalars['String']['output']>;
  jobRunId?: Maybe<Scalars['String']['output']>;
  outboundConfigHttpMethod?: Maybe<Scalars['String']['output']>;
  outboundConfigId?: Maybe<Scalars['String']['output']>;
  outboundConfigName?: Maybe<Scalars['String']['output']>;
  outboundConfigUrl?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type PagingDtoInput = {
  page: Scalars['Int']['input'];
  per_page: Scalars['Int']['input'];
};

export type ParLevelList = {
  __typename?: 'ParLevelList';
  assetLocationTypeName?: Maybe<Scalars['String']['output']>;
  assetTypeId: Scalars['String']['output'];
  assetTypeName: Scalars['String']['output'];
  buildingName?: Maybe<Scalars['String']['output']>;
  floorName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  locationTypeName?: Maybe<Scalars['String']['output']>;
  maxCount: Scalars['Int']['output'];
  minCount: Scalars['Int']['output'];
  returnResponse: Response;
  siteName?: Maybe<Scalars['String']['output']>;
  subBuildingName?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['Int']['output']>;
};

export type ParLevelListFilterInput = {
  and?: InputMaybe<Array<ParLevelListFilterInput>>;
  assetLocationTypeName?: InputMaybe<StringOperationFilterInput>;
  assetTypeId?: InputMaybe<StringOperationFilterInput>;
  assetTypeName?: InputMaybe<StringOperationFilterInput>;
  buildingName?: InputMaybe<StringOperationFilterInput>;
  floorName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  locationTypeName?: InputMaybe<StringOperationFilterInput>;
  maxCount?: InputMaybe<IntOperationFilterInput>;
  minCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ParLevelListFilterInput>>;
  returnResponse?: InputMaybe<ResponseFilterInput>;
  siteName?: InputMaybe<StringOperationFilterInput>;
  subBuildingName?: InputMaybe<StringOperationFilterInput>;
  target?: InputMaybe<IntOperationFilterInput>;
};

export type ParLevelListSortInput = {
  assetLocationTypeName?: InputMaybe<SortEnumType>;
  assetTypeId?: InputMaybe<SortEnumType>;
  assetTypeName?: InputMaybe<SortEnumType>;
  buildingName?: InputMaybe<SortEnumType>;
  floorName?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<SortEnumType>;
  locationTypeName?: InputMaybe<SortEnumType>;
  maxCount?: InputMaybe<SortEnumType>;
  minCount?: InputMaybe<SortEnumType>;
  returnResponse?: InputMaybe<ResponseSortInput>;
  siteName?: InputMaybe<SortEnumType>;
  subBuildingName?: InputMaybe<SortEnumType>;
  target?: InputMaybe<SortEnumType>;
};

export type ParLevelLocation = {
  __typename?: 'ParLevelLocation';
  locationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parLevels: Array<ParLevels>;
  parLevelsCount: Scalars['Int']['output'];
};


export type ParLevelLocationParLevelsArgs = {
  where?: InputMaybe<ParLevelsFilterInput>;
};

export type ParLevelLocationFilterInput = {
  and?: InputMaybe<Array<ParLevelLocationFilterInput>>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ParLevelLocationFilterInput>>;
  parLevels?: InputMaybe<ListFilterInputTypeOfParLevelsFilterInput>;
  parLevelsCount?: InputMaybe<IntOperationFilterInput>;
};

export type ParLevelLocationSortInput = {
  locationId?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parLevelsCount?: InputMaybe<SortEnumType>;
};

export type ParLevels = {
  __typename?: 'ParLevels';
  assetTypeId: Scalars['String']['output'];
  assetTypeName: Scalars['String']['output'];
  currentCount: Scalars['Int']['output'];
  maxCount: Scalars['Int']['output'];
  minCount: Scalars['Int']['output'];
  status: Scalars['Int']['output'];
  target: Scalars['Int']['output'];
};

export type ParLevelsFilterInput = {
  and?: InputMaybe<Array<ParLevelsFilterInput>>;
  assetTypeId?: InputMaybe<StringOperationFilterInput>;
  assetTypeName?: InputMaybe<StringOperationFilterInput>;
  currentCount?: InputMaybe<IntOperationFilterInput>;
  maxCount?: InputMaybe<IntOperationFilterInput>;
  minCount?: InputMaybe<IntOperationFilterInput>;
  or?: InputMaybe<Array<ParLevelsFilterInput>>;
  status?: InputMaybe<IntOperationFilterInput>;
  target?: InputMaybe<IntOperationFilterInput>;
};

export type Patient = {
  __typename?: 'Patient';
  id: Scalars['Int']['output'];
  secured_patient_name: Scalars['String']['output'];
  tag?: Maybe<PatientTag>;
  toJson: Scalars['String']['output'];
};

export type PatientInfo = {
  __typename?: 'PatientInfo';
  currentLocationAliasName?: Maybe<Scalars['String']['output']>;
  currentLocationId?: Maybe<Scalars['String']['output']>;
  currentLocationName?: Maybe<Scalars['String']['output']>;
  isWithStaff?: Maybe<Scalars['Boolean']['output']>;
  patientAppointments?: Maybe<Array<PatientInfoAppointment>>;
  patientAttendedMilestones?: Maybe<Array<PatientInfoAttendedMilestone>>;
  patientDepartmentVisitId: Scalars['String']['output'];
  patientStaffContacts?: Maybe<Array<PatientInfoStaffContact>>;
  patientWorkflows?: Maybe<Array<PatientInfoWorkflow>>;
  securable?: Maybe<PatientInfoSecurable>;
  securableId?: Maybe<Scalars['String']['output']>;
  securedPatientName?: Maybe<Scalars['String']['output']>;
  tagId?: Maybe<Scalars['String']['output']>;
  tagLastSensed?: Maybe<Scalars['DateTime']['output']>;
  tagValue?: Maybe<Scalars['String']['output']>;
  timeInLocation?: Maybe<Scalars['Int']['output']>;
  unattendedDurationInSeconds?: Maybe<Scalars['Int']['output']>;
  unattendedSinceUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type PatientInfoAppointment = {
  __typename?: 'PatientInfoAppointment';
  appointmentTimeUtc?: Maybe<Scalars['DateTime']['output']>;
  appointmentTypeId?: Maybe<Scalars['String']['output']>;
  appointmentTypeName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  patientDepartmentVisitId?: Maybe<Scalars['String']['output']>;
  providerFirstName?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  providerLastName?: Maybe<Scalars['String']['output']>;
};

export type PatientInfoAttendedMilestone = {
  __typename?: 'PatientInfoAttendedMilestone';
  isAttended?: Maybe<Scalars['Boolean']['output']>;
  patientAttendedMilestoneId?: Maybe<Scalars['String']['output']>;
  patientDepartmentVisitId?: Maybe<Scalars['String']['output']>;
};

export type PatientInfoSecurable = {
  __typename?: 'PatientInfoSecurable';
  first_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  mrn?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
};

export type PatientInfoStaffContact = {
  __typename?: 'PatientInfoStaffContact';
  patientDepartmentVisitId?: Maybe<Scalars['String']['output']>;
  patientStaffContactCreatedUtc?: Maybe<Scalars['DateTime']['output']>;
  patientStaffContactId?: Maybe<Scalars['String']['output']>;
  staffFirstName?: Maybe<Scalars['String']['output']>;
  staffId?: Maybe<Scalars['String']['output']>;
  staffLastName?: Maybe<Scalars['String']['output']>;
  staffTypeId?: Maybe<Scalars['Int']['output']>;
};

export type PatientInfoWorkflow = {
  __typename?: 'PatientInfoWorkflow';
  patientDepartmentVisitId?: Maybe<Scalars['String']['output']>;
  phases?: Maybe<Array<PatientInfoWorkflowPhase>>;
  timeInWorkflowSec?: Maybe<Scalars['Int']['output']>;
  workflowId?: Maybe<Scalars['String']['output']>;
  workflowName?: Maybe<Scalars['String']['output']>;
  workflowTypeId?: Maybe<Scalars['String']['output']>;
};

export type PatientInfoWorkflowPhase = {
  __typename?: 'PatientInfoWorkflowPhase';
  id?: Maybe<Scalars['String']['output']>;
  maxPhaseDurationMinutesHigh?: Maybe<Scalars['Int']['output']>;
  maxPhaseDurationMinutesLow?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  timeInPhaseSec?: Maybe<Scalars['Int']['output']>;
};

export type PatientTag = {
  __typename?: 'PatientTag';
  tag_value: Scalars['String']['output'];
};

export type ProbeDto = {
  __typename?: 'ProbeDto';
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  currentValue: Scalars['Float']['output'];
  customerId: Scalars['Int']['output'];
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  emItem?: Maybe<EmItemDto>;
  emItemId: Scalars['String']['output'];
  emTag?: Maybe<EmTagDto>;
  emTagId: Scalars['String']['output'];
  externalProbeId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  probeStats: Array<ProbeStatsDto>;
  probeType?: Maybe<ProbeTypeDto>;
  probeTypeId: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
  valueChangeDate?: Maybe<Scalars['DateTime']['output']>;
};


export type ProbeDtoProbeStatsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ProbeHistoryDto = {
  __typename?: 'ProbeHistoryDto';
  createdUtc: Scalars['DateTime']['output'];
  customerId: Scalars['Int']['output'];
  emItemId: Scalars['String']['output'];
  emTagId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  probeId: Scalars['String']['output'];
  probeTypeId: Scalars['Int']['output'];
  probeTypeName: Scalars['String']['output'];
  tagValue: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type ProbeStatsDto = {
  __typename?: 'ProbeStatsDto';
  dailyAverage?: Maybe<Scalars['Float']['output']>;
  dailyHighest?: Maybe<Scalars['Float']['output']>;
  dailyLowest?: Maybe<Scalars['Float']['output']>;
  dailyMKT?: Maybe<Scalars['Float']['output']>;
  hourlyAverage?: Maybe<Scalars['Float']['output']>;
  lastValue?: Maybe<Scalars['Float']['output']>;
  probeId: Scalars['String']['output'];
};

export type ProbeTypeDto = {
  __typename?: 'ProbeTypeDto';
  conversionIntercept?: Maybe<Scalars['Float']['output']>;
  conversionSlope?: Maybe<Scalars['Float']['output']>;
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  displayUnits?: Maybe<Scalars['String']['output']>;
  displayWordUnits?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  probes: Array<ProbeDto>;
  suffix?: Maybe<Scalars['String']['output']>;
  unitsReceived?: Maybe<Scalars['String']['output']>;
  unitsToStore?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type PublishEmRtlsMessageInput = {
  computedValue?: InputMaybe<Scalars['Float']['input']>;
  customerId: Scalars['Int']['input'];
  dataType?: InputMaybe<Scalars['String']['input']>;
  lastReader?: InputMaybe<Scalars['String']['input']>;
  postDate: Scalars['String']['input'];
  serial?: InputMaybe<Scalars['String']['input']>;
  tagValue: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type Query = {
  __typename?: 'Query';
  alertConditionEmItems: Array<AlertConditionEmItemDto>;
  alertEmItemsCount: Scalars['Int']['output'];
  alertRecipients: Array<AlertRecipientDto>;
  alertRecipientsCount: Scalars['Int']['output'];
  alertResponses: Array<AlertResponseDto>;
  alertResponsesCount: Scalars['Int']['output'];
  artAssetGroups?: Maybe<ArtAssetGroupsCollectionSegment>;
  artAssetTypes?: Maybe<ArtAssetTypesCollectionSegment>;
  artAssets?: Maybe<ArtAssetsCollectionSegment>;
  artCaLocationGroups?: Maybe<ArtCaLocationGroupsCollectionSegment>;
  artDepartmentDetails: Array<CaDepartment>;
  artExtractSearchState: ExtractSearchStateResponse;
  artInsightPrompts: ArtInsightPromptDetails;
  artLocationHierarchy?: Maybe<ArtLocationHierarchyCollectionSegment>;
  artLocationHistory?: Maybe<ArtLocationHistoryCollectionSegment>;
  artLocations?: Maybe<ArtLocationsCollectionSegment>;
  artOwnerDepartment: Array<DepartmentList>;
  artParLevelDashboard?: Maybe<ArtParLevelDashboardCollectionSegment>;
  artParLevels?: Maybe<ArtParLevelsCollectionSegment>;
  artReportConfiguration: ArtReportConfiguration;
  artRuleEvents?: Maybe<ArtRuleEventsCollectionSegment>;
  artRules?: Maybe<ArtRulesCollectionSegment>;
  artSavedSearches?: Maybe<ArtSavedSearchesCollectionSegment>;
  artScheduledNotifications?: Maybe<ArtScheduledNotificationsCollectionSegment>;
  artSearchAssets?: Maybe<ArtSearchAssetsCollectionSegment>;
  artSearchLocations?: Maybe<ArtSearchLocationsCollectionSegment>;
  artStaffGroups?: Maybe<ArtStaffGroupsCollectionSegment>;
  artStaffList?: Maybe<ArtStaffListCollectionSegment>;
  artStaffType: Array<CaStaffType>;
  authConfig: AuthConfigDto;
  authConfigs: AuthConfigListDto;
  availableCustomers: Array<CaCustomer>;
  buildings: Array<CaBuilding>;
  currentCustomer: CaCustomer;
  currentUser: CaUser;
  departmentShifts: Array<CaDepartmentShift>;
  departments: Array<CaDepartment>;
  duressAckMessages: Array<DefaultRespondMessage>;
  duressAckMessagesCount: DefaultMsgReplyCount;
  duressActionHistory: Array<DuressAction>;
  duressActionHistoryCount: DuressCountModel;
  duressAlerts: Array<DuressAlert>;
  duressEscalation: ReplyEscalation;
  duressEscalations: ReplyEscalations;
  duressEscalationsCount: ReplyEscalationsCount;
  duressEventHistory: Array<DuressAlert>;
  duressEventHistoryCount: DuressCountModel;
  duressOutboundMessage: ReplyOutboundMsg;
  duressOutboundMessages: ReplyOutboundMsgs;
  duressOutboundMessagesCount: ReplyOutboundMsgsCount;
  duressRegisterWindowsApp: ResponseWindowsApp;
  duressReportConfiguration: DuressReportConfiguration;
  duressRule: ReplyRule;
  duressRuleDepartments: ReplyRulesDepartment;
  duressRules: ReplyRules;
  duressRulesCount: ReplyRulesCount;
  duressStaff: Array<DuressStaff>;
  duressStaffCount: CaStaffInfoCount;
  emAlertConditions: Array<AlertConditionDto>;
  emAlertConditionsCount: Scalars['Int']['output'];
  emAlerts: Array<AlertDto>;
  emAlertsCount: Scalars['Int']['output'];
  emItemGroups: Array<EmItemGroupDto>;
  emItemGroupsCount: Scalars['Int']['output'];
  emItemTypes: Array<EmItemTypeDto>;
  emItemTypesCount: Scalars['Int']['output'];
  emItems: Array<EmItemDto>;
  emItemsCount: Scalars['Int']['output'];
  emItemsForAlertCondition: Array<AlertConditionEmItemDto>;
  emRecipientGroups: Array<RecipientGroupDto>;
  emRecipientGroupsCount: Scalars['Int']['output'];
  emTags: Array<EmTagDto>;
  emTagsCount: Scalars['Int']['output'];
  events: Array<EventResponseDto>;
  floorTagsInfo: Array<FloorTagReplyModel>;
  floors: Array<CaFloor>;
  handHygieneActivity?: Maybe<HandHygieneActivityConnection>;
  handHygieneActivityMilestones: Array<HhActivityMilestone>;
  handHygieneActivityMilestonesCount: HhCountModel;
  handHygieneComplianceStats: Array<KeyValuePairOfStringAndString>;
  handHygieneDepartments: Array<HhDepartment>;
  handHygieneDepartmentsCount: HhCountModel;
  handHygieneDevices: Array<HhDevice>;
  handHygieneDevicesCount: HhCountModel;
  handHygieneDispenserTypes: Array<HhDispenserType>;
  handHygieneEventList: Array<HhEvent>;
  handHygieneEventListCount: HhCountModel;
  handHygieneLocations: Array<HhLocation>;
  handHygieneLocationsCount: HhCountModel;
  handHygieneMessages: Array<HhMessageGroup>;
  handHygieneMessagesCount: HhCountModel;
  handHygienePrecautions: Array<HhPrecaution>;
  handHygieneReportConfiguration: HhReportConfiguration;
  handHygieneRules: Array<HhRule>;
  handHygieneRulesCount: HhCountModel;
  handHygieneStaff: Array<HhStaffDto>;
  handHygieneStaffCompliance?: Maybe<HandHygieneStaffComplianceConnection>;
  handHygieneStaffCompliancePercentage: HhStaffComplianceStat;
  handHygieneStaffCount: CaStaffInfoCount;
  hhLocationTypes: Array<HhLocationType>;
  integrateTemplates: Array<TemplateDto>;
  integrateTemplatesCount: Scalars['Int']['output'];
  integrationConfig: IntegrationConfigDto;
  integrationConfigSourceTypes: Array<IntegrationConfigSourceTypeOptionDto>;
  integrationConfigs: IntegrationConfigListDto;
  internalEvents: Array<InternalEventDto>;
  irtIncomingInternalEvents: Array<IrtIncomingInternalEventDto>;
  irtIncomingInternalEventsCount: Scalars['Int']['output'];
  irtIncomingPublishDestinations: Array<IrtIncomingPublishDestinationDto>;
  irtIncomingTransmissionHistory: Array<IncomingTransmissionHistoryDto>;
  irtIncomingTransmissionHistoryCount: Scalars['Int']['output'];
  irtIncomingWorkflowRun: IrtIncomingWorkflowRunDto;
  irtIncomingWorkflowRuns: Array<IrtIncomingWorkflowRunDto>;
  irtIncomingWorkflowRunsCount: Scalars['Int']['output'];
  irtIncomingWorkflows: Array<IrtIncomingWorkflowDto>;
  irtIncomingWorkflowsCount: Scalars['Int']['output'];
  irtOutgoingTransmissionHistory: Array<OutgoingTransmissionHistoryDto>;
  irtOutgoingTransmissionHistoryCount: Scalars['Int']['output'];
  irtOutgoingWorkflowRun: IrtOutgoingWorkflowRunDto;
  irtOutgoingWorkflowRuns: Array<IrtOutgoingWorkflowRunDto>;
  irtOutgoingWorkflowRunsCount: Scalars['Int']['output'];
  irtOutgoingWorkflows: Array<IrtOutgoingWorkflowDto>;
  irtOutgoingWorkflowsCount: Scalars['Int']['output'];
  jobRuns: JobRunListDto;
  latestHandHygieneActivitiesByFloor: Array<HhActivity>;
  locationStatuses: Array<LocationStatus>;
  locationTypes: Array<CaLocationTypeInfo>;
  locations: Array<CaLocation>;
  locationsCount: CaCountModel;
  mappingTemplate: MappingTemplateDto;
  mappingTemplates: MappingTemplateListDto;
  nistCertificate: NistCertificateDto;
  outboundConfigs: Array<OutboundConfigDto>;
  outboundConfigsCount: Scalars['Int']['output'];
  patients: Array<Patient>;
  patientsInfo: Array<PatientInfo>;
  patientsInfoCount: Scalars['Int']['output'];
  probeHistory: Array<ProbeHistoryDto>;
  probeHistoryCount: Scalars['Int']['output'];
  probeStats: Array<ProbeStatsDto>;
  probeTypes: Array<ProbeTypeDto>;
  probeTypesCount: Scalars['Int']['output'];
  probes: Array<ProbeDto>;
  probesCount: Scalars['Int']['output'];
  sensors: Array<CaSensor>;
  sensorsCount: CaCountModel;
  sites: Array<CaSite>;
  staff: Array<CaStaff>;
  staffTypes: Array<CaStaffType>;
  staffTypesCount: CaCountModel;
  statusUpdateMessages: Array<StatusUpdateRespondMessage>;
  statusUpdateMessagesCount: StatusUpdateMsgReplyCount;
  subBuildings: Array<CaSubBuilding>;
  tagAssigneeInfo: Array<LiveTagAssigneeInfo>;
  tags: Array<CaTag>;
  userNotification?: Maybe<UserNotification>;
};


export type QueryAlertConditionEmItemsArgs = {
  alertConditionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  emItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAlertEmItemsCountArgs = {
  alertConditionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  emItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAlertRecipientsArgs = {
  alertConditionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  recipientGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  staffIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAlertRecipientsCountArgs = {
  alertConditionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  staffIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryAlertResponsesArgs = {
  alertIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAlertResponsesCountArgs = {
  alertIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArtAssetGroupsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Array<AssetGroupsSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetGroupsFilterInput>;
};


export type QueryArtAssetTypesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Array<AssetTypesSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetTypesFilterInput>;
};


export type QueryArtAssetsArgs = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Array<AssetsSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetsFilterInput>;
};


export type QueryArtCaLocationGroupsArgs = {
  order?: InputMaybe<Array<LocationGroupsSortInput>>;
  siteid?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LocationGroupsFilterInput>;
};


export type QueryArtDepartmentDetailsArgs = {
  order?: InputMaybe<Array<CaDepartmentSortInput>>;
  where?: InputMaybe<CaDepartmentFilterInput>;
};


export type QueryArtExtractSearchStateArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArtLocationHierarchyArgs = {
  order?: InputMaybe<Array<CaFloorListSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CaFloorListFilterInput>;
};


export type QueryArtLocationHistoryArgs = {
  endDate: Scalars['DateTime']['input'];
  id: Scalars['String']['input'];
  order?: InputMaybe<Array<LocationsSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  startDate: Scalars['DateTime']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<LocationsFilterInput>;
};


export type QueryArtLocationsArgs = {
  isParLevelData?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Array<AssetLocationListSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetLocationListFilterInput>;
};


export type QueryArtOwnerDepartmentArgs = {
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryArtParLevelDashboardArgs = {
  order?: InputMaybe<Array<ParLevelLocationSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ParLevelLocationFilterInput>;
};


export type QueryArtParLevelsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Array<ParLevelListSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ParLevelListFilterInput>;
};


export type QueryArtRuleEventsArgs = {
  endUtc: Scalars['DateTime']['input'];
  order?: InputMaybe<Array<RuleEventRecordSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  startUtc: Scalars['DateTime']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RuleEventRecordFilterInput>;
};


export type QueryArtRulesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Array<RuleSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<RuleFilterInput>;
};


export type QueryArtSavedSearchesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Array<SavedSearchesSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SavedSearchesFilterInput>;
};


export type QueryArtScheduledNotificationsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Array<ScheduledNotificationSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ScheduledNotificationFilterInput>;
};


export type QueryArtSearchAssetsArgs = {
  order?: InputMaybe<Array<AssetsSortInput>>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetsFilterInput>;
};


export type QueryArtSearchLocationsArgs = {
  order?: InputMaybe<Array<SearchLocationsSortInput>>;
  refresh?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<SearchLocationsFilterInput>;
};


export type QueryArtStaffGroupsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Array<StaffGroupsSortInput>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<StaffGroupsFilterInput>;
};


export type QueryArtStaffListArgs = {
  order?: InputMaybe<Array<CaStaffListSortInput>>;
  paging?: InputMaybe<PagingDtoInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<SortingDtoInput>;
  staffIds?: InputMaybe<StaffDtoInput>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<CaStaffListFilterInput>;
};


export type QueryAuthConfigArgs = {
  id: Scalars['String']['input'];
};


export type QueryAuthConfigsArgs = {
  authType?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBuildingsArgs = {
  filters?: InputMaybe<HierarchyBuildingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryDepartmentShiftsArgs = {
  departmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryDepartmentsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryDuressAckMessagesArgs = {
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryDuressActionHistoryArgs = {
  actionfilter?: InputMaybe<ActionFilteringDtoInput>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryDuressActionHistoryCountArgs = {
  actionfilter?: InputMaybe<ActionFilteringDtoInput>;
};


export type QueryDuressEscalationArgs = {
  data: GetEscalationDtoInput;
};


export type QueryDuressEscalationsArgs = {
  obMsgfilter?: InputMaybe<GetEscalationFilterDtoInput>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryDuressEscalationsCountArgs = {
  obMsgCountfilter?: InputMaybe<GetEscalationFilterDtoInput>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryDuressEventHistoryArgs = {
  eventfilter?: InputMaybe<EventFilteringDtoInput>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryDuressEventHistoryCountArgs = {
  eventfilter?: InputMaybe<EventFilteringDtoInput>;
};


export type QueryDuressOutboundMessageArgs = {
  data: GetOutboundMsgDtoInput;
};


export type QueryDuressOutboundMessagesArgs = {
  obMsgfilter?: InputMaybe<GetOutboundMsgFilterDtoInput>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryDuressOutboundMessagesCountArgs = {
  obMsgCountfilter?: InputMaybe<GetOutboundMsgFilterDtoInput>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryDuressRegisterWindowsAppArgs = {
  windowsAppFilterDto: WindowsAppFilterDtoInput;
};


export type QueryDuressRuleArgs = {
  data: GetRuleDtoInput;
};


export type QueryDuressRuleDepartmentsArgs = {
  rulesDeptFilter: GetRulesDepartmentFilterDtoInput;
};


export type QueryDuressRulesArgs = {
  paging?: InputMaybe<PagingDtoInput>;
  rulesfilter?: InputMaybe<GetRulesFilterDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryDuressRulesCountArgs = {
  paging?: InputMaybe<PagingDtoInput>;
  rulesCountFilter?: InputMaybe<GetRulesFilterDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryDuressStaffArgs = {
  actionfilter?: InputMaybe<ActionFilteringDtoInput>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
  staffIds?: InputMaybe<StaffDtoInput>;
};


export type QueryDuressStaffCountArgs = {
  actionfilter?: InputMaybe<ActionFilteringDtoInput>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
  staffIds?: InputMaybe<StaffDtoInput>;
};


export type QueryEmAlertConditionsArgs = {
  autoResponseEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  probeTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reopenIfOutOfRangeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  repeatMode?: InputMaybe<Scalars['String']['input']>;
  rollingAvgTriggerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmAlertConditionsCountArgs = {
  autoResponseEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  probeTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reopenIfOutOfRangeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  repeatMode?: InputMaybe<Scalars['String']['input']>;
  rollingAvgTriggerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmAlertsArgs = {
  acknowledgedBy?: InputMaybe<Scalars['String']['input']>;
  alertConditionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  emItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  probeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmAlertsCountArgs = {
  acknowledgedBy?: InputMaybe<Scalars['String']['input']>;
  alertConditionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  emItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  probeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmItemGroupsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmItemGroupsCountArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryEmItemTypesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmItemTypesCountArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmItemsArgs = {
  emItemTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  probeTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmItemsCountArgs = {
  emItemTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  probeTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryEmItemsForAlertConditionArgs = {
  alertConditionId: Scalars['String']['input'];
};


export type QueryEmRecipientGroupsArgs = {
  caDepartmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmRecipientGroupsCountArgs = {
  caDepartmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmTagsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryEmTagsCountArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryFloorTagsInfoArgs = {
  FloorTagInfoRequest?: InputMaybe<FloorTagInfoRequestInput>;
};


export type QueryFloorsArgs = {
  filters?: InputMaybe<HierarchyFloorDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryHandHygieneActivityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deptId?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<HhActivitySortInput>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  where?: InputMaybe<HhActivityFilterInput>;
};


export type QueryHandHygieneActivityMilestonesArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filters?: InputMaybe<ActivityMilestoneFilterDtoInput>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryHandHygieneActivityMilestonesCountArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filters?: InputMaybe<ActivityMilestoneFilterDtoInput>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryHandHygieneComplianceStatsArgs = {
  deptId: Scalars['String']['input'];
  where?: InputMaybe<KeyValuePairOfStringAndStringFilterInput>;
};


export type QueryHandHygieneDepartmentsArgs = {
  caDepartmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryHandHygieneDepartmentsCountArgs = {
  caDepartmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryHandHygieneDevicesArgs = {
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  paging?: InputMaybe<PagingDtoInput>;
  sensorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryHandHygieneDevicesCountArgs = {
  deviceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sensorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryHandHygieneDispenserTypesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryHandHygieneEventListArgs = {
  floorId: Scalars['Int']['input'];
  paging?: InputMaybe<PagingDtoInput>;
  staffId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHandHygieneEventListCountArgs = {
  floorId: Scalars['Int']['input'];
};


export type QueryHandHygieneLocationsArgs = {
  filters?: InputMaybe<LocationsArgsDtoInput>;
  paging?: InputMaybe<PagingDtoInput>;
};


export type QueryHandHygieneLocationsCountArgs = {
  filters?: InputMaybe<LocationsArgsDtoInput>;
};


export type QueryHandHygieneMessagesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryHandHygieneMessagesCountArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryHandHygienePrecautionsArgs = {
  precautionIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryHandHygieneRulesArgs = {
  departmentId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryHandHygieneRulesCountArgs = {
  departmentId?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  messageGroupId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHandHygieneStaffArgs = {
  actionfilter?: InputMaybe<ActFilteringDtoInput>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
  staffIds?: InputMaybe<StaffDtoInput>;
};


export type QueryHandHygieneStaffComplianceArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deptId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<HhStaffComplianceSortInput>>;
  where?: InputMaybe<HhStaffComplianceFilterInput>;
};


export type QueryHandHygieneStaffCompliancePercentageArgs = {
  input: StaffCompliancePercentageDtoInput;
};


export type QueryHandHygieneStaffCountArgs = {
  actionfilter?: InputMaybe<ActFilteringDtoInput>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
  staffIds?: InputMaybe<StaffDtoInput>;
};


export type QueryIntegrateTemplatesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  internalEventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIntegrateTemplatesCountArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  internalEventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIntegrationConfigArgs = {
  id: Scalars['String']['input'];
};


export type QueryIntegrationConfigsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInternalEventsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIrtIncomingInternalEventsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIrtIncomingInternalEventsCountArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIrtIncomingTransmissionHistoryArgs = {
  deliveryMode?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  integrationConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  internalEventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['Int']['input']>>;
  templateIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryIrtIncomingTransmissionHistoryCountArgs = {
  deliveryMode?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  integrationConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  internalEventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['Int']['input']>>;
  templateIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryIrtIncomingWorkflowRunArgs = {
  id: Scalars['String']['input'];
};


export type QueryIrtIncomingWorkflowRunsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  workflowIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryIrtIncomingWorkflowRunsCountArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  workflowIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryIrtIncomingWorkflowsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIrtIncomingWorkflowsCountArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIrtOutgoingTransmissionHistoryArgs = {
  deliveryMode?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  internalEventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Scalars['String']['input']>;
  outboundConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['Int']['input']>>;
  templateIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryIrtOutgoingTransmissionHistoryCountArgs = {
  deliveryMode?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  internalEventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  outboundConfigIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['Int']['input']>>;
  templateIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryIrtOutgoingWorkflowRunArgs = {
  id: Scalars['String']['input'];
};


export type QueryIrtOutgoingWorkflowRunsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  workflowIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryIrtOutgoingWorkflowRunsCountArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  workflowIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryIrtOutgoingWorkflowsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryIrtOutgoingWorkflowsCountArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryJobRunsArgs = {
  configIds?: InputMaybe<Array<Scalars['String']['input']>>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLatestHandHygieneActivitiesByFloorArgs = {
  floorId: Scalars['String']['input'];
};


export type QueryLocationStatusesArgs = {
  filters?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryLocationsArgs = {
  filters?: InputMaybe<LocationsDtoInput>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryLocationsCountArgs = {
  filters?: InputMaybe<LocationsDtoInput>;
};


export type QueryMappingTemplateArgs = {
  id: Scalars['String']['input'];
};


export type QueryMappingTemplatesArgs = {
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNistCertificateArgs = {
  deviceType: Scalars['Int']['input'];
  id: Scalars['String']['input'];
};


export type QueryOutboundConfigsArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  internalEventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOutboundConfigsCountArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  internalEventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPatientsArgs = {
  activePatients?: InputMaybe<Scalars['Boolean']['input']>;
  tag_values?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPatientsInfoArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  patientDepartmentVisitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  tagValues?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryPatientsInfoCountArgs = {
  patientDepartmentVisitIds?: InputMaybe<Array<Scalars['String']['input']>>;
  tagValues?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryProbeHistoryArgs = {
  emTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate: Scalars['DateTime']['input'];
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  probeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  tagValues?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryProbeHistoryCountArgs = {
  emTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate: Scalars['DateTime']['input'];
  probeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate: Scalars['DateTime']['input'];
  tagValues?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryProbeStatsArgs = {
  emTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  probeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  tagValues?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryProbeTypesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProbeTypesCountArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProbesArgs = {
  emItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  emTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  externalProbeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  nulls?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  probeTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProbesCountArgs = {
  emItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  emTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  externalProbeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  probeTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySensorsArgs = {
  filters?: InputMaybe<SensorsDtoInput>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QuerySensorsCountArgs = {
  filters?: InputMaybe<SensorsDtoInput>;
};


export type QuerySitesArgs = {
  filters?: InputMaybe<HierarchySiteDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryStaffArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryStatusUpdateMessagesArgs = {
  paging?: InputMaybe<PagingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QuerySubBuildingsArgs = {
  filters?: InputMaybe<HierarchySubBuildingDtoInput>;
  sorting?: InputMaybe<SortingDtoInput>;
};


export type QueryTagAssigneeInfoArgs = {
  requestTagAssignee?: InputMaybe<RequestTagAssigneeInput>;
};


export type QueryTagsArgs = {
  paging?: InputMaybe<PagingDtoInput>;
  search?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<SortingDtoInput>;
};

export type RDepartmentsInput = {
  departmentId: Scalars['Int']['input'];
  departmentName: Scalars['String']['input'];
};

export type RecipeintsIds = {
  __typename?: 'RecipeintsIds';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<RecipeintsIds>;
  departmentId?: Maybe<Scalars['String']['output']>;
  staffId?: Maybe<Scalars['String']['output']>;
};

export type RecipientGroupDto = {
  __typename?: 'RecipientGroupDto';
  alertEmItems: Array<AlertConditionEmItemDto>;
  alertRecipients: Array<AlertRecipientDto>;
  alertRecipientsCount: Scalars['Int']['output'];
  caDepartmentIds?: Maybe<Array<Scalars['Int']['output']>>;
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  customerId: Scalars['Int']['output'];
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  outboundType?: Maybe<Array<Scalars['Int']['output']>>;
  title: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type RecipientGroupRecipientInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  staffId?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterIoTDeviceRequestDtoInput = {
  clientId: Scalars['String']['input'];
  deviceId: Scalars['UUID']['input'];
  eventTypeId?: InputMaybe<Array<Scalars['String']['input']>>;
  senderRegistrationId: Scalars['String']['input'];
};

export type RegisterIoTDeviceResponseDto = {
  __typename?: 'RegisterIoTDeviceResponseDto';
  certificate?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  deviceId: Scalars['UUID']['output'];
  events?: Maybe<Array<EventDto>>;
  privateKey?: Maybe<Scalars['String']['output']>;
  senderRegistrationId: Scalars['String']['output'];
};

export type RegisterWpnClientDtoInput = {
  appId: Scalars['String']['input'];
  channelUri: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
};

export type RemoveArtRuleDtoInput = {
  id: Scalars['String']['input'];
};

export type RemoveAssetDtoInput = {
  assetId: Scalars['String']['input'];
};

export type RemoveAssetGroupDtoInput = {
  id: Scalars['String']['input'];
};

export type RemoveAssetTypeDtoInput = {
  assetTypeId: Scalars['String']['input'];
};

export type RemoveDepartmentDtoInput = {
  id: Scalars['String']['input'];
};

export type RemoveMessageGroupDtoInput = {
  id: Scalars['String']['input'];
};

export type RemoveModel = {
  __typename?: 'RemoveModel';
  affected: Scalars['Int']['output'];
};

export type RemoveParLevelDtoInput = {
  parLevelId: Scalars['String']['input'];
};

export type RemoveRuleDtoInput = {
  id: Scalars['String']['input'];
};

export type RemoveSavedSearchesInput = {
  savedId: Scalars['String']['input'];
};

export type RemoveScheduledNotification = {
  __typename?: 'RemoveScheduledNotification';
  id: Scalars['String']['output'];
  returnResponse: Response;
};

export type RemoveStaffGroupDtoInput = {
  id: Scalars['String']['input'];
};

export type ReplyEscalation = {
  __typename?: 'ReplyEscalation';
  calculateSize: Scalars['Int']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  clone?: Maybe<ReplyEscalation>;
  escalationDepartments?: Maybe<Array<Maybe<ReplyEscalationDepartment>>>;
  escalationId?: Maybe<Scalars['String']['output']>;
  escalationLevels?: Maybe<Array<Maybe<ReplyEscalationLevel>>>;
  escalationName?: Maybe<Scalars['String']['output']>;
  updatedOn?: Maybe<Scalars['String']['output']>;
};

export type ReplyEscalationDepartment = {
  __typename?: 'ReplyEscalationDepartment';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<ReplyEscalationDepartment>;
  escalationDeptId?: Maybe<Scalars['String']['output']>;
  escalationId?: Maybe<Scalars['String']['output']>;
  triggerDepartmentId: Scalars['Int']['output'];
};

export type ReplyEscalationLevel = {
  __typename?: 'ReplyEscalationLevel';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<ReplyEscalationLevel>;
  escalationId?: Maybe<Scalars['String']['output']>;
  escalationLevelEnable: Scalars['Boolean']['output'];
  escalationLevelGroups?: Maybe<Array<Maybe<ReplyEscalationLevelGroup>>>;
  escalationLevelId?: Maybe<Scalars['String']['output']>;
  escalationLevelName?: Maybe<Scalars['String']['output']>;
  level: Scalars['Int']['output'];
  nextLevelescalationTime: Scalars['Int']['output'];
};

export type ReplyEscalationLevelGroup = {
  __typename?: 'ReplyEscalationLevelGroup';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<ReplyEscalationLevelGroup>;
  escalationLevelGroupdId?: Maybe<Scalars['String']['output']>;
  escalationLevelId?: Maybe<Scalars['String']['output']>;
  messageGroupId?: Maybe<Scalars['String']['output']>;
};

export type ReplyEscalations = {
  __typename?: 'ReplyEscalations';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<ReplyEscalations>;
  replyEscalation?: Maybe<Array<Maybe<ReplyEscalation>>>;
};

export type ReplyEscalationsCount = {
  __typename?: 'ReplyEscalationsCount';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<ReplyEscalationsCount>;
  count: Scalars['Int']['output'];
};

export type ReplyOutboundMsg = {
  __typename?: 'ReplyOutboundMsg';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<ReplyOutboundMsg>;
  departmentIds?: Maybe<Array<Scalars['Int']['output']>>;
  enableNearProximity: Scalars['Boolean']['output'];
  groupId?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  outboundTypes?: Maybe<Array<Maybe<OutboundTypes>>>;
  recipeintsIds?: Maybe<Array<Maybe<RecipeintsIds>>>;
  triggerDepartmentId: Scalars['Int']['output'];
  updatedOn?: Maybe<Scalars['String']['output']>;
};

export type ReplyOutboundMsgs = {
  __typename?: 'ReplyOutboundMsgs';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<ReplyOutboundMsgs>;
  replyOutboundMsg?: Maybe<Array<Maybe<ReplyOutboundMsg>>>;
};

export type ReplyOutboundMsgsCount = {
  __typename?: 'ReplyOutboundMsgsCount';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<ReplyOutboundMsgsCount>;
  count: Scalars['Int']['output'];
};

export type ReplyRule = {
  __typename?: 'ReplyRule';
  audioFile?: Maybe<Scalars['String']['output']>;
  calculateSize: Scalars['Int']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  clone?: Maybe<ReplyRule>;
  isAssigned: Scalars['Boolean']['output'];
  isAudioEnabled: Scalars['Boolean']['output'];
  isCreateAlert: Scalars['Boolean']['output'];
  keyBitDecimal: Scalars['Int']['output'];
  ruleId: Scalars['Int']['output'];
  ruleName?: Maybe<Scalars['String']['output']>;
  rulesDepartment?: Maybe<Array<Maybe<RulesDepartment>>>;
  updatedDateTime?: Maybe<Timestamp>;
};

export type ReplyRules = {
  __typename?: 'ReplyRules';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<ReplyRules>;
  replyRules_?: Maybe<Array<Maybe<ReplyRule>>>;
};

export type ReplyRulesCount = {
  __typename?: 'ReplyRulesCount';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<ReplyRulesCount>;
  count: Scalars['Int']['output'];
};

export type ReplyRulesDepartment = {
  __typename?: 'ReplyRulesDepartment';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<ReplyRulesDepartment>;
  rulesDepartment?: Maybe<Array<Maybe<RulesDepartment>>>;
};

export type ReplyStatus = {
  __typename?: 'ReplyStatus';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<ReplyStatus>;
  message?: Maybe<Scalars['String']['output']>;
  status: Scalars['Boolean']['output'];
};

export type RequestAddUpdateIoTDeviceDtoInput = {
  devices: Array<AddUpdateIoTDeviceDtoInput>;
};

export type RequestTagAssigneeInput = {
  tag_value: Array<Scalars['String']['input']>;
};

export type Response = {
  __typename?: 'Response';
  code?: Maybe<Scalars['String']['output']>;
  errorType?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ResponseFilterInput = {
  and?: InputMaybe<Array<ResponseFilterInput>>;
  code?: InputMaybe<StringOperationFilterInput>;
  errorType?: InputMaybe<StringOperationFilterInput>;
  fieldName?: InputMaybe<StringOperationFilterInput>;
  message?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ResponseFilterInput>>;
};

export type ResponseSortInput = {
  code?: InputMaybe<SortEnumType>;
  errorType?: InputMaybe<SortEnumType>;
  fieldName?: InputMaybe<SortEnumType>;
  message?: InputMaybe<SortEnumType>;
};

export type ResponseWindowsApp = {
  __typename?: 'ResponseWindowsApp';
  authAudience?: Maybe<Scalars['String']['output']>;
  authDomain?: Maybe<Scalars['String']['output']>;
  authOrgName?: Maybe<Scalars['String']['output']>;
  authOrgid?: Maybe<Scalars['String']['output']>;
  authRedirectUrl?: Maybe<Scalars['String']['output']>;
  authUIClientId?: Maybe<Scalars['String']['output']>;
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<ResponseWindowsApp>;
  mapUrl?: Maybe<Scalars['String']['output']>;
  mobAuthClientId?: Maybe<Scalars['String']['output']>;
  mobMapAPIKey?: Maybe<Scalars['String']['output']>;
  mobMapId?: Maybe<Scalars['String']['output']>;
  registerId?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  windowAppId?: Maybe<Scalars['String']['output']>;
};

export type Rule = {
  __typename?: 'Rule';
  allAssets: Scalars['Boolean']['output'];
  assetGroups: Array<AssetGroup>;
  assetTypeName: Scalars['String']['output'];
  delay?: Maybe<Scalars['Int']['output']>;
  direction?: Maybe<AreaRestrictionDirection>;
  id: Scalars['String']['output'];
  locationGroupIds?: Maybe<Array<Scalars['Int']['output']>>;
  locationGroups?: Maybe<Array<LocationGroup>>;
  locationName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parLevelId: Scalars['String']['output'];
  returnResponse: Response;
  ruleAction: RuleAction;
  type: RuleType;
};

export type RuleAction = {
  __typename?: 'RuleAction';
  id: Scalars['String']['output'];
  staffGroups: Array<StaffGroup>;
  type: RuleActionType;
};

export type RuleActionFilterInput = {
  and?: InputMaybe<Array<RuleActionFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RuleActionFilterInput>>;
  staffGroups?: InputMaybe<ListFilterInputTypeOfStaffGroupFilterInput>;
  type?: InputMaybe<RuleActionTypeOperationFilterInput>;
};

export type RuleActionInput = {
  staffGroupIds: Array<Scalars['String']['input']>;
  type: RuleActionType;
};

export type RuleActionSortInput = {
  id?: InputMaybe<SortEnumType>;
  type?: InputMaybe<SortEnumType>;
};

export enum RuleActionType {
  EmailNotification = 'EMAIL_NOTIFICATION',
  EmailSmsnotification = 'EMAIL_SMSNOTIFICATION',
  Smsnotification = 'SMSNOTIFICATION'
}

export type RuleActionTypeOperationFilterInput = {
  eq?: InputMaybe<RuleActionType>;
  in?: InputMaybe<Array<RuleActionType>>;
  neq?: InputMaybe<RuleActionType>;
  nin?: InputMaybe<Array<RuleActionType>>;
};

export type RuleEventRecord = {
  __typename?: 'RuleEventRecord';
  assetId?: Maybe<Scalars['String']['output']>;
  assetName?: Maybe<Scalars['String']['output']>;
  createdUtc?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  locationGroups?: Maybe<Scalars['String']['output']>;
  parLevel?: Maybe<Scalars['String']['output']>;
  ruleActionType?: Maybe<Scalars['String']['output']>;
  ruleId?: Maybe<Scalars['String']['output']>;
  ruleName: Scalars['String']['output'];
  ruleType?: Maybe<Scalars['String']['output']>;
  staffGroups?: Maybe<Scalars['String']['output']>;
  tagNumber: Scalars['String']['output'];
};

export type RuleEventRecordFilterInput = {
  and?: InputMaybe<Array<RuleEventRecordFilterInput>>;
  assetId?: InputMaybe<StringOperationFilterInput>;
  assetName?: InputMaybe<StringOperationFilterInput>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationGroups?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RuleEventRecordFilterInput>>;
  parLevel?: InputMaybe<StringOperationFilterInput>;
  ruleActionType?: InputMaybe<StringOperationFilterInput>;
  ruleId?: InputMaybe<StringOperationFilterInput>;
  ruleName?: InputMaybe<StringOperationFilterInput>;
  ruleType?: InputMaybe<StringOperationFilterInput>;
  staffGroups?: InputMaybe<StringOperationFilterInput>;
  tagNumber?: InputMaybe<StringOperationFilterInput>;
};

export type RuleEventRecordSortInput = {
  assetId?: InputMaybe<SortEnumType>;
  assetName?: InputMaybe<SortEnumType>;
  createdUtc?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locationGroups?: InputMaybe<SortEnumType>;
  parLevel?: InputMaybe<SortEnumType>;
  ruleActionType?: InputMaybe<SortEnumType>;
  ruleId?: InputMaybe<SortEnumType>;
  ruleName?: InputMaybe<SortEnumType>;
  ruleType?: InputMaybe<SortEnumType>;
  staffGroups?: InputMaybe<SortEnumType>;
  tagNumber?: InputMaybe<SortEnumType>;
};

export type RuleFilterInput = {
  allAssets?: InputMaybe<BooleanOperationFilterInput>;
  and?: InputMaybe<Array<RuleFilterInput>>;
  assetGroups?: InputMaybe<ListFilterInputTypeOfAssetGroupFilterInput>;
  assetTypeName?: InputMaybe<StringOperationFilterInput>;
  delay?: InputMaybe<IntOperationFilterInput>;
  direction?: InputMaybe<NullableOfAreaRestrictionDirectionOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  locationGroupIds?: InputMaybe<ListIntOperationFilterInput>;
  locationGroups?: InputMaybe<ListFilterInputTypeOfLocationGroupFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<RuleFilterInput>>;
  parLevelId?: InputMaybe<StringOperationFilterInput>;
  returnResponse?: InputMaybe<ResponseFilterInput>;
  ruleAction?: InputMaybe<RuleActionFilterInput>;
  type?: InputMaybe<RuleTypeOperationFilterInput>;
};

export type RuleSortInput = {
  allAssets?: InputMaybe<SortEnumType>;
  assetTypeName?: InputMaybe<SortEnumType>;
  delay?: InputMaybe<SortEnumType>;
  direction?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  parLevelId?: InputMaybe<SortEnumType>;
  returnResponse?: InputMaybe<ResponseSortInput>;
  ruleAction?: InputMaybe<RuleActionSortInput>;
  type?: InputMaybe<SortEnumType>;
};

export enum RuleType {
  AreaRestriction = 'AREA_RESTRICTION',
  ButtonPress = 'BUTTON_PRESS',
  ParAboveThreshold = 'PAR_ABOVE_THRESHOLD',
  ParBelowThreshold = 'PAR_BELOW_THRESHOLD'
}

export type RuleTypeOperationFilterInput = {
  eq?: InputMaybe<RuleType>;
  in?: InputMaybe<Array<RuleType>>;
  neq?: InputMaybe<RuleType>;
  nin?: InputMaybe<Array<RuleType>>;
};

export type RulesDepartment = {
  __typename?: 'RulesDepartment';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<RulesDepartment>;
  departmentId: Scalars['Int']['output'];
  departmentName?: Maybe<Scalars['String']['output']>;
};

export type SavedSearches = {
  __typename?: 'SavedSearches';
  createdOn?: Maybe<Scalars['DateTime']['output']>;
  filters: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  query?: Maybe<Scalars['String']['output']>;
  returnResponse: Response;
};

export type SavedSearchesFilterInput = {
  and?: InputMaybe<Array<SavedSearchesFilterInput>>;
  createdOn?: InputMaybe<DateTimeOperationFilterInput>;
  filters?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<SavedSearchesFilterInput>>;
  query?: InputMaybe<StringOperationFilterInput>;
  returnResponse?: InputMaybe<ResponseFilterInput>;
};

export type SavedSearchesSortInput = {
  createdOn?: InputMaybe<SortEnumType>;
  filters?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  query?: InputMaybe<SortEnumType>;
  returnResponse?: InputMaybe<ResponseSortInput>;
};

export type ScheduledNotification = {
  __typename?: 'ScheduledNotification';
  createdUtc: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  filters: Scalars['String']['output'];
  frequency: Scalars['Int']['output'];
  frequencyParameter?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  lastSent?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  orderColumn?: Maybe<Scalars['String']['output']>;
  orderDirection?: Maybe<Scalars['String']['output']>;
  returnResponse: Response;
  staffGroupIds: Array<Scalars['String']['output']>;
  staffGroupNames: Array<Scalars['String']['output']>;
  startHour: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
  updatedUtc: Scalars['DateTime']['output'];
};

export type ScheduledNotificationFilterInput = {
  and?: InputMaybe<Array<ScheduledNotificationFilterInput>>;
  createdUtc?: InputMaybe<DateTimeOperationFilterInput>;
  enabled?: InputMaybe<BooleanOperationFilterInput>;
  filters?: InputMaybe<StringOperationFilterInput>;
  frequency?: InputMaybe<IntOperationFilterInput>;
  frequencyParameter?: InputMaybe<IntOperationFilterInput>;
  id?: InputMaybe<StringOperationFilterInput>;
  lastSent?: InputMaybe<DateTimeOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<ScheduledNotificationFilterInput>>;
  orderColumn?: InputMaybe<StringOperationFilterInput>;
  orderDirection?: InputMaybe<StringOperationFilterInput>;
  returnResponse?: InputMaybe<ResponseFilterInput>;
  staffGroupIds?: InputMaybe<ListStringOperationFilterInput>;
  staffGroupNames?: InputMaybe<ListStringOperationFilterInput>;
  startHour?: InputMaybe<IntOperationFilterInput>;
  timezone?: InputMaybe<StringOperationFilterInput>;
  updatedUtc?: InputMaybe<DateTimeOperationFilterInput>;
};

export type ScheduledNotificationSortInput = {
  createdUtc?: InputMaybe<SortEnumType>;
  enabled?: InputMaybe<SortEnumType>;
  filters?: InputMaybe<SortEnumType>;
  frequency?: InputMaybe<SortEnumType>;
  frequencyParameter?: InputMaybe<SortEnumType>;
  id?: InputMaybe<SortEnumType>;
  lastSent?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  orderColumn?: InputMaybe<SortEnumType>;
  orderDirection?: InputMaybe<SortEnumType>;
  returnResponse?: InputMaybe<ResponseSortInput>;
  startHour?: InputMaybe<SortEnumType>;
  timezone?: InputMaybe<SortEnumType>;
  updatedUtc?: InputMaybe<SortEnumType>;
};

export type SearchLocations = {
  __typename?: 'SearchLocations';
  assets?: Maybe<AssetsCollectionSegment>;
  buildingId?: Maybe<Scalars['Int']['output']>;
  buildingName?: Maybe<Scalars['String']['output']>;
  floorId?: Maybe<Scalars['Int']['output']>;
  floorName?: Maybe<Scalars['String']['output']>;
  locationId: Scalars['String']['output'];
  locationName: Scalars['String']['output'];
  locationType: LocationsType;
  parLevelData?: Maybe<Scalars['Boolean']['output']>;
  siteId: Scalars['Int']['output'];
  siteName: Scalars['String']['output'];
  subBuildingId?: Maybe<Scalars['Int']['output']>;
  subBuildingName?: Maybe<Scalars['String']['output']>;
};


export type SearchLocationsAssetsArgs = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AssetsFilterInput>;
};

export type SearchLocationsFilterInput = {
  and?: InputMaybe<Array<SearchLocationsFilterInput>>;
  assets?: InputMaybe<ListFilterInputTypeOfAssetsFilterInput>;
  buildingId?: InputMaybe<IntOperationFilterInput>;
  buildingName?: InputMaybe<StringOperationFilterInput>;
  floorId?: InputMaybe<IntOperationFilterInput>;
  floorName?: InputMaybe<StringOperationFilterInput>;
  locationId?: InputMaybe<StringOperationFilterInput>;
  locationName?: InputMaybe<StringOperationFilterInput>;
  locationType?: InputMaybe<LocationsTypeOperationFilterInput>;
  or?: InputMaybe<Array<SearchLocationsFilterInput>>;
  parLevelData?: InputMaybe<BooleanOperationFilterInput>;
  siteId?: InputMaybe<IntOperationFilterInput>;
  siteName?: InputMaybe<StringOperationFilterInput>;
  subBuildingId?: InputMaybe<IntOperationFilterInput>;
  subBuildingName?: InputMaybe<StringOperationFilterInput>;
};

export type SearchLocationsSortInput = {
  buildingId?: InputMaybe<SortEnumType>;
  buildingName?: InputMaybe<SortEnumType>;
  floorId?: InputMaybe<SortEnumType>;
  floorName?: InputMaybe<SortEnumType>;
  locationId?: InputMaybe<SortEnumType>;
  locationName?: InputMaybe<SortEnumType>;
  locationType?: InputMaybe<SortEnumType>;
  parLevelData?: InputMaybe<SortEnumType>;
  siteId?: InputMaybe<SortEnumType>;
  siteName?: InputMaybe<SortEnumType>;
  subBuildingId?: InputMaybe<SortEnumType>;
  subBuildingName?: InputMaybe<SortEnumType>;
};

export type SensorsDtoInput = {
  locationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sensorTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum SortEnumType {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortingDtoInput = {
  fieldName: Scalars['String']['input'];
  nulls?: InputMaybe<EOrderNullsType>;
  order?: InputMaybe<EOrderType>;
};

export type StaffCompliancePercentageDtoInput = {
  floorId: Scalars['Int']['input'];
  locationValue?: InputMaybe<Scalars['String']['input']>;
  staffId?: InputMaybe<Scalars['String']['input']>;
};

export type StaffDtoInput = {
  departmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  endUTC?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  stafftypeid?: InputMaybe<Array<Scalars['Int']['input']>>;
  startUTC?: InputMaybe<Scalars['String']['input']>;
  tagids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type StaffGroup = {
  __typename?: 'StaffGroup';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<StaffGroup>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type StaffGroupFilterInput = {
  and?: InputMaybe<Array<StaffGroupFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StaffGroupFilterInput>>;
};

export type StaffGroups = {
  __typename?: 'StaffGroups';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  returnResponse: Response;
  staff: Array<StaffMember>;
  staffNames?: Maybe<Array<Scalars['String']['output']>>;
};

export type StaffGroupsFilterInput = {
  and?: InputMaybe<Array<StaffGroupsFilterInput>>;
  id?: InputMaybe<StringOperationFilterInput>;
  name?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StaffGroupsFilterInput>>;
  returnResponse?: InputMaybe<ResponseFilterInput>;
  staff?: InputMaybe<ListFilterInputTypeOfStaffMemberFilterInput>;
  staffNames?: InputMaybe<ListStringOperationFilterInput>;
};

export type StaffGroupsSortInput = {
  id?: InputMaybe<SortEnumType>;
  name?: InputMaybe<SortEnumType>;
  returnResponse?: InputMaybe<ResponseSortInput>;
};

export type StaffMember = {
  __typename?: 'StaffMember';
  firstName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  lastName: Scalars['String']['output'];
};

export type StaffMemberFilterInput = {
  and?: InputMaybe<Array<StaffMemberFilterInput>>;
  firstName?: InputMaybe<StringOperationFilterInput>;
  id?: InputMaybe<IntOperationFilterInput>;
  lastName?: InputMaybe<StringOperationFilterInput>;
  or?: InputMaybe<Array<StaffMemberFilterInput>>;
};

export type Status = {
  __typename?: 'Status';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<Status>;
  message?: Maybe<Scalars['String']['output']>;
  status_: Scalars['Boolean']['output'];
};

export type StatusMessage = {
  __typename?: 'StatusMessage';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<StatusMessage>;
  idx?: Maybe<Scalars['String']['output']>;
  isCriticalResponse: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedOn?: Maybe<Scalars['String']['output']>;
};

export type StatusUpdateMsgDtoInput = {
  quickActionOrder?: InputMaybe<Scalars['Int']['input']>;
  statusUpdateId?: InputMaybe<Scalars['String']['input']>;
  statusUpdateName: Scalars['String']['input'];
};

export type StatusUpdateMsgReplyCount = {
  __typename?: 'StatusUpdateMsgReplyCount';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<StatusUpdateMsgReplyCount>;
  count: Scalars['Int']['output'];
};

export type StatusUpdateRespondMessage = {
  __typename?: 'StatusUpdateRespondMessage';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<StatusUpdateRespondMessage>;
  hasQuickActionOrder: Scalars['Boolean']['output'];
  quickActionOrder: Scalars['Int']['output'];
  statusUpdateId?: Maybe<Scalars['String']['output']>;
  statusUpdateName?: Maybe<Scalars['String']['output']>;
};

export type StringOperationFilterInput = {
  and?: InputMaybe<Array<StringOperationFilterInput>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ncontains?: InputMaybe<Scalars['String']['input']>;
  nendsWith?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  nin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nstartsWith?: InputMaybe<Scalars['String']['input']>;
  or?: InputMaybe<Array<StringOperationFilterInput>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  onAdherenceChangeReceived: HhActivity;
  onBtnPressReceived: BtnPressAlertData;
  onLiveLocationReceived: TagMovement;
};


export type SubscriptionOnAdherenceChangeReceivedArgs = {
  floorId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type SubscriptionOnBtnPressReceivedArgs = {
  token: Scalars['String']['input'];
};


export type SubscriptionOnLiveLocationReceivedArgs = {
  floorId: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type SyncAssetTagDtoInput = {
  assetId: Scalars['String']['input'];
};

export type TagMovement = {
  __typename?: 'TagMovement';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<TagMovement>;
  customerId?: Maybe<Scalars['String']['output']>;
  fromAltitude: Scalars['Float']['output'];
  fromFloor?: Maybe<Scalars['String']['output']>;
  fromLatitude: Scalars['Float']['output'];
  fromLocationValue?: Maybe<Scalars['String']['output']>;
  fromLongitude: Scalars['Float']['output'];
  hasFromFloor: Scalars['Boolean']['output'];
  hasLocationType: Scalars['Boolean']['output'];
  hasToFloor: Scalars['Boolean']['output'];
  locationType?: Maybe<Scalars['String']['output']>;
  tagValue?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Timestamp>;
  toAltitude: Scalars['Float']['output'];
  toFloor?: Maybe<Scalars['String']['output']>;
  toLatitude: Scalars['Float']['output'];
  toLocationValue?: Maybe<Scalars['String']['output']>;
  toLongitude: Scalars['Float']['output'];
  vendor?: Maybe<Scalars['String']['output']>;
};

export enum TemplateBodyEncoding {
  Base64 = 'BASE64',
  Plain = 'PLAIN'
}

export type TemplateDto = {
  __typename?: 'TemplateDto';
  body: Scalars['String']['output'];
  createdBy: Scalars['String']['output'];
  createdUtc: Scalars['DateTime']['output'];
  customerId: Scalars['String']['output'];
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedUtc?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  internalEventId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  updatedUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type Timestamp = {
  __typename?: 'Timestamp';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<Timestamp>;
  nanos: Scalars['Int']['output'];
  seconds: Scalars['Long']['output'];
  toDateTime: Scalars['DateTime']['output'];
  toDateTimeOffset: Scalars['DateTime']['output'];
  toDiagnosticString?: Maybe<Scalars['String']['output']>;
};

export type TriggerIntegrationConfigDto = {
  __typename?: 'TriggerIntegrationConfigDto';
  configId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  triggerTime: Scalars['String']['output'];
};

export type UpdateArtRuleDtoInput = {
  assetGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  delay?: InputMaybe<Scalars['Int']['input']>;
  direction?: InputMaybe<AreaRestrictionDirection>;
  id: Scalars['String']['input'];
  locationGroupIds: Array<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  parLevelId: Scalars['String']['input'];
  ruleAction: RuleActionInput;
  type: RuleType;
};

export type UpdateAlertConditionEmItemsResponse = {
  __typename?: 'UpdateAlertConditionEmItemsResponse';
  added: Scalars['Int']['output'];
  removed: Scalars['Int']['output'];
};

export type UpdateAlertConditionInput = {
  allowUserToSpecifyReopenTime?: InputMaybe<Scalars['Boolean']['input']>;
  autoResponseEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  autoResponseMessage?: InputMaybe<Scalars['String']['input']>;
  autoResponseTimeMin?: InputMaybe<Scalars['Int']['input']>;
  emItemIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
  maxValue?: InputMaybe<Scalars['Int']['input']>;
  minValue?: InputMaybe<Scalars['Int']['input']>;
  probeTypeId?: InputMaybe<Scalars['String']['input']>;
  recipientGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  reopenIfOutOfRangeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  reopenTimeMin?: InputMaybe<Scalars['Int']['input']>;
  repeatDelayMin?: InputMaybe<Scalars['Int']['input']>;
  repeatMode?: InputMaybe<Scalars['String']['input']>;
  rollingAvgTriggerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAlertInput = {
  acknowledgedBy?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAlertRecipientInput = {
  alertConditionId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  recipientGroupId?: InputMaybe<Scalars['String']['input']>;
  reportAfterMin?: InputMaybe<Scalars['Int']['input']>;
  staffId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAlertResponseInput = {
  id: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAssetDtoInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  assetGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  assetGroupNames?: InputMaybe<Array<Scalars['String']['input']>>;
  assetNumber?: InputMaybe<Scalars['String']['input']>;
  assetTypeId?: InputMaybe<Scalars['String']['input']>;
  assetTypeName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerDepartment?: InputMaybe<Scalars['String']['input']>;
  preventativeMaintenanceDue?: InputMaybe<Scalars['String']['input']>;
  preventativeMaintenanceLastPerformed?: InputMaybe<Scalars['String']['input']>;
  rental?: InputMaybe<Scalars['Boolean']['input']>;
  rentalDateIssued?: InputMaybe<Scalars['String']['input']>;
  rentalExpectedReturnDate?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  tagNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAssetGroupDtoInput = {
  assetGroupId: Scalars['String']['input'];
  assets?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateAssetTypeDtoInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAuthConfigInput = {
  authConfig?: InputMaybe<Scalars['String']['input']>;
  authType?: InputMaybe<Scalars['String']['input']>;
  encoding: TemplateBodyEncoding;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDepartmentDtoInput = {
  id: Scalars['String']['input'];
  minTargetCompliance: Scalars['Int']['input'];
};

export type UpdateDeviceDtoInput = {
  deviceId: Scalars['String']['input'];
  dispenserTypeId?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateEmItemGroupInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmItemInput = {
  customId?: InputMaybe<Scalars['String']['input']>;
  departmentId?: InputMaybe<Scalars['Int']['input']>;
  emItemTypeId?: InputMaybe<Scalars['String']['input']>;
  firstCheckTime?: InputMaybe<Scalars['String']['input']>;
  historicalSaveRate?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  inMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  secondCheckTime?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmItemTypeInput = {
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmTagInput = {
  id: Scalars['String']['input'];
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  tagValue?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHhRuleDtoInput = {
  caLocationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  caLocationTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  caStaffTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  departmentId: Scalars['String']['input'];
  entryDispenserTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  entryEnabled: Scalars['Boolean']['input'];
  entrySecondsToRemainInTheRoom?: InputMaybe<Scalars['Int']['input']>;
  entrySecondsToRemainOutOfTheRoom?: InputMaybe<Scalars['Int']['input']>;
  exitDispenserTypeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  exitEnabled: Scalars['Boolean']['input'];
  exitSecondsToRemainInTheRoom?: InputMaybe<Scalars['Int']['input']>;
  exitSecondsToRemainOutOfTheRoom?: InputMaybe<Scalars['Int']['input']>;
  hhLocationTypeId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  messageGroupIds: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  precautionId?: InputMaybe<Scalars['Int']['input']>;
  secondsToWashAfterEnterTheRoom?: InputMaybe<Scalars['Int']['input']>;
  secondsToWashAfterExitTheRoom?: InputMaybe<Scalars['Int']['input']>;
  secondsToWashBeforeEnterTheRoom?: InputMaybe<Scalars['Int']['input']>;
  secondsToWashBeforeExitTheRoom?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateIntegrationConfigInput = {
  authConfigId?: InputMaybe<Scalars['String']['input']>;
  encoding: TemplateBodyEncoding;
  endpointUrl: Scalars['String']['input'];
  httpMethod?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  internalEventId: Scalars['String']['input'];
  intervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  isEnabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  requestHeaders: Scalars['String']['input'];
  schedule?: InputMaybe<Array<Scalars['String']['input']>>;
  sftpFilePath?: InputMaybe<Scalars['String']['input']>;
  sourceType: Scalars['String']['input'];
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateIrtIncomingWorkflowInput = {
  direction?: InputMaybe<Scalars['String']['input']>;
  encoding?: InputMaybe<TemplateBodyEncoding>;
  graph?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  intervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateIrtOutgoingWorkflowInput = {
  direction?: InputMaybe<Scalars['String']['input']>;
  encoding?: InputMaybe<TemplateBodyEncoding>;
  graph?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  intervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateLocationDtoInput = {
  locationId: Scalars['String']['input'];
  precautionId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMappingTemplateInput = {
  id: Scalars['String']['input'];
  internalEventId?: InputMaybe<Scalars['String']['input']>;
  mapping?: InputMaybe<Scalars['String']['input']>;
  mappingEncoding: TemplateBodyEncoding;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMessageGroupDtoInput = {
  groupName: Scalars['String']['input'];
  id: Scalars['String']['input'];
  outboundType: Array<Scalars['Int']['input']>;
  staffIds: Array<Scalars['Int']['input']>;
};

export type UpdateOutboundConfigInput = {
  authConfigId?: InputMaybe<Scalars['String']['input']>;
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  encoding: TemplateBodyEncoding;
  headers?: InputMaybe<Scalars['String']['input']>;
  httpMethod?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  internalEventId?: InputMaybe<Scalars['String']['input']>;
  intervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  schedule?: InputMaybe<Array<Scalars['String']['input']>>;
  templateId?: InputMaybe<Scalars['String']['input']>;
  transportType?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateParLevelDtoInput = {
  assetTypeId?: InputMaybe<Scalars['String']['input']>;
  assetTypeName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  locationId?: InputMaybe<Array<Scalars['String']['input']>>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  maxCount?: InputMaybe<Scalars['Int']['input']>;
  minCount?: InputMaybe<Scalars['Int']['input']>;
  target?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProbeInput = {
  emItemId?: InputMaybe<Scalars['String']['input']>;
  emTagId?: InputMaybe<Scalars['String']['input']>;
  externalProbeId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  probeTypeId: Scalars['String']['input'];
};

export type UpdateProbeTypeInput = {
  conversionIntercept?: InputMaybe<Scalars['Float']['input']>;
  conversionSlope?: InputMaybe<Scalars['Float']['input']>;
  displayUnits?: InputMaybe<Scalars['String']['input']>;
  displayWordUnits?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  unitsReceived?: InputMaybe<Scalars['String']['input']>;
  unitsToStore?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRecipientGroupInput = {
  caDepartmentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['String']['input'];
  outboundType?: InputMaybe<Array<Scalars['Int']['input']>>;
  recipients?: InputMaybe<Array<RecipientGroupRecipientInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReplyStatus = {
  __typename?: 'UpdateReplyStatus';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<UpdateReplyStatus>;
  id?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type UpdateRespondMsgDtoInput = {
  msgId: Scalars['Int']['input'];
  priorityId: Scalars['Int']['input'];
  respondMessage: Scalars['String']['input'];
};

export type UpdateScheduledNotificationInput = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<Scalars['String']['input']>;
  frequency?: InputMaybe<Scalars['Int']['input']>;
  frequencyParameter?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  orderColumn?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  staffGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startHour?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateStaffGroupDtoInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  staffIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  staffNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateTemplateInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  bodyEncoding: TemplateBodyEncoding;
  id: Scalars['String']['input'];
  internalEventId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotification = {
  __typename?: 'UserNotification';
  created_utc?: Maybe<Scalars['DateTime']['output']>;
  expiration_utc?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  notification_message?: Maybe<Scalars['String']['output']>;
  notification_title?: Maybe<Scalars['String']['output']>;
};

export type WindowsAppFilterDtoInput = {
  alertMngrDeviceId: Scalars['String']['input'];
  alertMngrWebUrl: Scalars['String']['input'];
};

export type WnsSubscriptionResponse = {
  __typename?: 'WnsSubscriptionResponse';
  calculateSize: Scalars['Int']['output'];
  clone?: Maybe<WnsSubscriptionResponse>;
  wnsSubscriptionId?: Maybe<Scalars['String']['output']>;
};

export type EventTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type EventTypesQuery = { __typename?: 'Query', internalEvents: Array<{ __typename?: 'InternalEventDto', id: string, name: string, availableFields?: string | null, transport?: string | null }> };

export type IncomingHistoriesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  deliveryMode?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type IncomingHistoriesQuery = { __typename?: 'Query', irtIncomingTransmissionHistoryCount: number, irtIncomingTransmissionHistory: Array<{ __typename?: 'IncomingTransmissionHistoryDto', id: string, integrationConfigId?: string | null, integrationConfigName?: string | null, integrationConfigUrl?: string | null, integrationConfigHttpMethod?: string | null, internalEventName?: string | null, templateName?: string | null, errorMessage?: string | null, status?: number | null, createdUtc: any, deliveryMode?: string | null, jobRunId?: string | null }> };

export type InternalEventsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type InternalEventsQuery = { __typename?: 'Query', internalEvents: Array<{ __typename?: 'InternalEventDto', id: string, name: string, availableFields?: string | null, description?: string | null, endpointUrl?: string | null, protocol?: string | null, isEnabled?: boolean | null, transport?: string | null }> };

export type GetJobRunsQueryVariables = Exact<{
  configIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  nulls?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetJobRunsQuery = { __typename?: 'Query', jobRuns: { __typename?: 'JobRunListDto', totalCount: number, jobRuns: Array<{ __typename?: 'JobRunListItemDto', runId: string, configId: string, configName: string, lastJobRunAt: string, finishedAt?: string | null, durationSeconds?: number | null, status?: string | null, pullRetryCount: number, errorMessage?: string | null, stats?: { __typename?: 'JobRunStatsDto', created?: number | null, updated?: number | null, deleted?: number | null, failed?: number | null } | null }> } };

export type GetMappingTemplatesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  nulls?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetMappingTemplatesQuery = { __typename?: 'Query', mappingTemplates: { __typename?: 'MappingTemplateListDto', totalCount: number, mappingTemplates: Array<{ __typename?: 'MappingTemplateDto', templateId: string, name: string, internalEventId: string, mapping: string, usageCount: number }> } };

export type GetMappingTemplateQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GetMappingTemplateQuery = { __typename?: 'Query', mappingTemplate: { __typename?: 'MappingTemplateDto', templateId: string, name: string, internalEventId: string, mapping: string, usageCount: number } };

export type CreateMappingTemplateMutationVariables = Exact<{
  input: CreateMappingTemplateInput;
}>;


export type CreateMappingTemplateMutation = { __typename?: 'Mutation', createMappingTemplate: { __typename?: 'MappingTemplateDto', templateId: string, name: string, internalEventId: string, mapping: string, usageCount: number } };

export type UpdateMappingTemplateMutationVariables = Exact<{
  input: UpdateMappingTemplateInput;
}>;


export type UpdateMappingTemplateMutation = { __typename?: 'Mutation', updateMappingTemplate: { __typename?: 'MappingTemplateDto', templateId: string, name: string, internalEventId: string, mapping: string, usageCount: number } };

export type RemoveMappingTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveMappingTemplateMutation = { __typename?: 'Mutation', removeMappingTemplate: boolean };

export type OutboundConfigsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type OutboundConfigsQuery = { __typename?: 'Query', outboundConfigsCount: number, outboundConfigs: Array<{ __typename?: 'OutboundConfigDto', id: string, customerId: string, name: string, url: string, httpMethod: string, internalEventId: string, templateId: string, authConfigId?: string | null, headers?: string | null, transportType?: string | null, batchSize?: number | null, schedule: Array<string>, intervalMinutes?: number | null, isEnabled?: boolean | null, createdUtc: any, createdBy: string, updatedUtc?: any | null, updatedBy?: string | null, deletedUtc?: any | null, deletedBy?: string | null, template?: { __typename?: 'TemplateDto', name: string } | null, internalEvent?: { __typename?: 'InternalEventDto', name: string } | null }> };

export type OutboundConfigQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type OutboundConfigQuery = { __typename?: 'Query', outboundConfigs: Array<{ __typename?: 'OutboundConfigDto', id: string, customerId: string, name: string, url: string, httpMethod: string, internalEventId: string, templateId: string, authConfigId?: string | null, headers?: string | null, transportType?: string | null, batchSize?: number | null, schedule: Array<string>, intervalMinutes?: number | null, isEnabled?: boolean | null, createdUtc: any, createdBy: string, updatedUtc?: any | null, updatedBy?: string | null, deletedUtc?: any | null, deletedBy?: string | null, template?: { __typename?: 'TemplateDto', name: string } | null, internalEvent?: { __typename?: 'InternalEventDto', name: string } | null }> };

export type CreateOutboundConfigMutationVariables = Exact<{
  record: CreateOutboundConfigInput;
}>;


export type CreateOutboundConfigMutation = { __typename?: 'Mutation', createOutboundConfig: { __typename?: 'OutboundConfigDto', id: string, url: string, httpMethod: string, customerId: string, internalEventId: string, authConfigId?: string | null } };

export type UpdateOutboundConfigMutationVariables = Exact<{
  record: UpdateOutboundConfigInput;
}>;


export type UpdateOutboundConfigMutation = { __typename?: 'Mutation', updateOutboundConfig: { __typename?: 'OutboundConfigDto', id: string, url: string, httpMethod: string, customerId: string, internalEventId: string, authConfigId?: string | null } };

export type RemoveOutboundConfigMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveOutboundConfigMutation = { __typename?: 'Mutation', removeOutboundConfig: boolean };

export type OutgoingHistoriesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  deliveryMode?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type OutgoingHistoriesQuery = { __typename?: 'Query', irtOutgoingTransmissionHistoryCount: number, irtOutgoingTransmissionHistory: Array<{ __typename?: 'OutgoingTransmissionHistoryDto', id: string, outboundConfigName?: string | null, outboundConfigUrl?: string | null, outboundConfigHttpMethod?: string | null, internalEventName?: string | null, templateName?: string | null, errorMessage?: string | null, status?: number | null, createdUtc: any, deliveryMode?: string | null, jobRunId?: string | null }> };

export type TemplatesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type TemplatesQuery = { __typename?: 'Query', integrateTemplatesCount: number, integrateTemplates: Array<{ __typename?: 'TemplateDto', id: string, customerId: string, name: string, body: string, internalEventId: string, createdUtc: any, createdBy: string, updatedUtc?: any | null, updatedBy?: string | null, deletedUtc?: any | null, deletedBy?: string | null }> };

export type TemplateQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type TemplateQuery = { __typename?: 'Query', integrateTemplatesCount: number, integrateTemplates: Array<{ __typename?: 'TemplateDto', id: string, customerId: string, name: string, body: string, internalEventId: string, createdUtc: any, createdBy: string, updatedUtc?: any | null, updatedBy?: string | null, deletedUtc?: any | null, deletedBy?: string | null }> };

export type CreateTemplateMutationVariables = Exact<{
  record: CreateTemplateInput;
}>;


export type CreateTemplateMutation = { __typename?: 'Mutation', createIntegrateTemplate: { __typename?: 'TemplateDto', id: string, customerId: string, name: string, body: string, internalEventId: string, createdUtc: any, createdBy: string, updatedUtc?: any | null, updatedBy?: string | null, deletedUtc?: any | null, deletedBy?: string | null } };

export type UpdateTemplateMutationVariables = Exact<{
  record: UpdateTemplateInput;
}>;


export type UpdateTemplateMutation = { __typename?: 'Mutation', updateIntegrateTemplate: { __typename?: 'TemplateDto', id: string, customerId: string, name: string, body: string, internalEventId: string, createdUtc: any, createdBy: string, updatedUtc?: any | null, updatedBy?: string | null, deletedUtc?: any | null, deletedBy?: string | null } };

export type RemoveTemplateMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RemoveTemplateMutation = { __typename?: 'Mutation', removeIntegrateTemplate: boolean };

export const EventTypesDocument = gql`
    query EventTypes {
  internalEvents {
    id
    name
    availableFields
    transport
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EventTypesGQL extends Apollo.Query<EventTypesQuery, EventTypesQueryVariables> {
    override document = EventTypesDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IncomingHistoriesDocument = gql`
    query IncomingHistories($page: Int, $perPage: Int, $deliveryMode: String, $search: String, $sort: String, $order: String) {
  irtIncomingTransmissionHistory(
    page: $page
    perPage: $perPage
    deliveryMode: $deliveryMode
    search: $search
    sort: $sort
    order: $order
  ) {
    id
    integrationConfigId
    integrationConfigName
    integrationConfigUrl
    integrationConfigHttpMethod
    internalEventName
    templateName
    errorMessage
    status
    createdUtc
    deliveryMode
    jobRunId
  }
  irtIncomingTransmissionHistoryCount(
    deliveryMode: $deliveryMode
    search: $search
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IncomingHistoriesGQL extends Apollo.Query<IncomingHistoriesQuery, IncomingHistoriesQueryVariables> {
    override document = IncomingHistoriesDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InternalEventsDocument = gql`
    query InternalEvents($ids: [String!], $search: String) {
  internalEvents(ids: $ids, search: $search) {
    id
    name
    availableFields
    description
    endpointUrl
    protocol
    isEnabled
    transport
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InternalEventsGQL extends Apollo.Query<InternalEventsQuery, InternalEventsQueryVariables> {
    override document = InternalEventsDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetJobRunsDocument = gql`
    query GetJobRuns($configIds: [String!], $status: String, $dateFrom: String, $dateTo: String, $page: Int, $perPage: Int, $sort: String, $order: String, $nulls: String) {
  jobRuns(
    configIds: $configIds
    status: $status
    dateFrom: $dateFrom
    dateTo: $dateTo
    page: $page
    perPage: $perPage
    sort: $sort
    order: $order
    nulls: $nulls
  ) {
    jobRuns {
      runId
      configId
      configName
      lastJobRunAt
      finishedAt
      durationSeconds
      status
      stats {
        created
        updated
        deleted
        failed
      }
      pullRetryCount
      errorMessage
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetJobRunsGQL extends Apollo.Query<GetJobRunsQuery, GetJobRunsQueryVariables> {
    override document = GetJobRunsDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMappingTemplatesDocument = gql`
    query GetMappingTemplates($page: Int, $perPage: Int, $search: String, $sort: String, $order: String, $nulls: String) {
  mappingTemplates(
    page: $page
    perPage: $perPage
    search: $search
    sort: $sort
    order: $order
    nulls: $nulls
  ) {
    mappingTemplates {
      templateId
      name
      internalEventId
      mapping
      usageCount
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMappingTemplatesGQL extends Apollo.Query<GetMappingTemplatesQuery, GetMappingTemplatesQueryVariables> {
    override document = GetMappingTemplatesDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMappingTemplateDocument = gql`
    query GetMappingTemplate($id: String!) {
  mappingTemplate(id: $id) {
    templateId
    name
    internalEventId
    mapping
    usageCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMappingTemplateGQL extends Apollo.Query<GetMappingTemplateQuery, GetMappingTemplateQueryVariables> {
    override document = GetMappingTemplateDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMappingTemplateDocument = gql`
    mutation CreateMappingTemplate($input: CreateMappingTemplateInput!) {
  createMappingTemplate(input: $input) {
    templateId
    name
    internalEventId
    mapping
    usageCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMappingTemplateGQL extends Apollo.Mutation<CreateMappingTemplateMutation, CreateMappingTemplateMutationVariables> {
    override document = CreateMappingTemplateDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMappingTemplateDocument = gql`
    mutation UpdateMappingTemplate($input: UpdateMappingTemplateInput!) {
  updateMappingTemplate(input: $input) {
    templateId
    name
    internalEventId
    mapping
    usageCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMappingTemplateGQL extends Apollo.Mutation<UpdateMappingTemplateMutation, UpdateMappingTemplateMutationVariables> {
    override document = UpdateMappingTemplateDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveMappingTemplateDocument = gql`
    mutation RemoveMappingTemplate($id: String!) {
  removeMappingTemplate(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveMappingTemplateGQL extends Apollo.Mutation<RemoveMappingTemplateMutation, RemoveMappingTemplateMutationVariables> {
    override document = RemoveMappingTemplateDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OutboundConfigsDocument = gql`
    query OutboundConfigs($page: Int, $perPage: Int, $search: String, $sort: String, $order: String) {
  outboundConfigs(
    page: $page
    perPage: $perPage
    search: $search
    sort: $sort
    order: $order
  ) {
    id
    customerId
    name
    url
    httpMethod
    internalEventId
    templateId
    authConfigId
    template {
      name
    }
    internalEvent {
      name
    }
    headers
    transportType
    batchSize
    schedule
    intervalMinutes
    isEnabled
    createdUtc
    createdBy
    updatedUtc
    updatedBy
    deletedUtc
    deletedBy
  }
  outboundConfigsCount(search: $search)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OutboundConfigsGQL extends Apollo.Query<OutboundConfigsQuery, OutboundConfigsQueryVariables> {
    override document = OutboundConfigsDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OutboundConfigDocument = gql`
    query OutboundConfig($id: String!) {
  outboundConfigs(ids: [$id]) {
    id
    customerId
    name
    url
    httpMethod
    internalEventId
    templateId
    authConfigId
    template {
      name
    }
    internalEvent {
      name
    }
    headers
    transportType
    batchSize
    schedule
    intervalMinutes
    isEnabled
    createdUtc
    createdBy
    updatedUtc
    updatedBy
    deletedUtc
    deletedBy
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OutboundConfigGQL extends Apollo.Query<OutboundConfigQuery, OutboundConfigQueryVariables> {
    override document = OutboundConfigDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOutboundConfigDocument = gql`
    mutation CreateOutboundConfig($record: CreateOutboundConfigInput!) {
  createOutboundConfig(input: $record) {
    id
    url
    httpMethod
    customerId
    internalEventId
    authConfigId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOutboundConfigGQL extends Apollo.Mutation<CreateOutboundConfigMutation, CreateOutboundConfigMutationVariables> {
    override document = CreateOutboundConfigDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateOutboundConfigDocument = gql`
    mutation UpdateOutboundConfig($record: UpdateOutboundConfigInput!) {
  updateOutboundConfig(input: $record) {
    id
    url
    httpMethod
    customerId
    internalEventId
    authConfigId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOutboundConfigGQL extends Apollo.Mutation<UpdateOutboundConfigMutation, UpdateOutboundConfigMutationVariables> {
    override document = UpdateOutboundConfigDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveOutboundConfigDocument = gql`
    mutation RemoveOutboundConfig($id: String!) {
  removeOutboundConfig(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveOutboundConfigGQL extends Apollo.Mutation<RemoveOutboundConfigMutation, RemoveOutboundConfigMutationVariables> {
    override document = RemoveOutboundConfigDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OutgoingHistoriesDocument = gql`
    query OutgoingHistories($page: Int, $perPage: Int, $deliveryMode: String, $search: String, $sort: String, $order: String) {
  irtOutgoingTransmissionHistory(
    page: $page
    perPage: $perPage
    deliveryMode: $deliveryMode
    search: $search
    sort: $sort
    order: $order
  ) {
    id
    outboundConfigName
    outboundConfigUrl
    outboundConfigHttpMethod
    internalEventName
    templateName
    errorMessage
    status
    createdUtc
    deliveryMode
    jobRunId
  }
  irtOutgoingTransmissionHistoryCount(
    deliveryMode: $deliveryMode
    search: $search
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OutgoingHistoriesGQL extends Apollo.Query<OutgoingHistoriesQuery, OutgoingHistoriesQueryVariables> {
    override document = OutgoingHistoriesDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TemplatesDocument = gql`
    query Templates($page: Int, $perPage: Int, $search: String, $sort: String, $order: String) {
  integrateTemplates(
    page: $page
    perPage: $perPage
    search: $search
    sort: $sort
    order: $order
  ) {
    id
    customerId
    name
    body
    internalEventId
    createdUtc
    createdBy
    updatedUtc
    updatedBy
    deletedUtc
    deletedBy
  }
  integrateTemplatesCount(search: $search)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplatesGQL extends Apollo.Query<TemplatesQuery, TemplatesQueryVariables> {
    override document = TemplatesDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TemplateDocument = gql`
    query Template($id: String!) {
  integrateTemplates(ids: [$id]) {
    id
    customerId
    name
    body
    internalEventId
    createdUtc
    createdBy
    updatedUtc
    updatedBy
    deletedUtc
    deletedBy
  }
  integrateTemplatesCount
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TemplateGQL extends Apollo.Query<TemplateQuery, TemplateQueryVariables> {
    override document = TemplateDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTemplateDocument = gql`
    mutation CreateTemplate($record: CreateTemplateInput!) {
  createIntegrateTemplate(input: $record) {
    id
    customerId
    name
    body
    internalEventId
    createdUtc
    createdBy
    updatedUtc
    updatedBy
    deletedUtc
    deletedBy
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTemplateGQL extends Apollo.Mutation<CreateTemplateMutation, CreateTemplateMutationVariables> {
    override document = CreateTemplateDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTemplateDocument = gql`
    mutation UpdateTemplate($record: UpdateTemplateInput!) {
  updateIntegrateTemplate(input: $record) {
    id
    customerId
    name
    body
    internalEventId
    createdUtc
    createdBy
    updatedUtc
    updatedBy
    deletedUtc
    deletedBy
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTemplateGQL extends Apollo.Mutation<UpdateTemplateMutation, UpdateTemplateMutationVariables> {
    override document = UpdateTemplateDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveTemplateDocument = gql`
    mutation RemoveTemplate($id: String!) {
  removeIntegrateTemplate(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveTemplateGQL extends Apollo.Mutation<RemoveTemplateMutation, RemoveTemplateMutationVariables> {
    override document = RemoveTemplateDocument;
    override client = 'API';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }